import { de as deDateLocale, enGB as enDateLocale } from "date-fns/locale";
import { getLocale } from "../../i18n";
import { useTranslation } from "react-i18next";
import { translate as tr } from "../../i18n";
import React, { useEffect, useState, useRef, useMemo, lazy, Suspense } from "react";
import { useSelector } from "react-redux";
import axios from "axios";
import "../../utils/chartjs";
import { Bar, Doughnut, PolarArea } from "react-chartjs-2";
import DatePicker from "react-datepicker";
import SideBar from "../common/sidebar";
import html2canvas from "html2canvas";
import {
  subDays,
  eachDayOfInterval,
  eachWeekOfInterval,
  startOfWeek,
  endOfWeek,
  startOfMonth,
  endOfMonth,
  startOfDay,
  endOfDay,
  format,
  startOfYear,
  endOfYear,
  eachMonthOfInterval,
  addDays,
  getDate,
  getMonth,
  parseISO,
  differenceInCalendarDays,
} from "date-fns";
import Logo from "../common/Logo";
import { Modal } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import moment from "moment-timezone";
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";
import { NavLink } from "react-router-dom";
import Loader from "../common/loader";
import { alterTimeFormat, alterDisplayTime } from "../common/displayTime";
import DateRangePicker from "../common/DateRangePicker";
import Footer from "../common/footer";
import "../../assets/css/reports.css";
import "../../assets/css/dashboard.css";
const Detailed = lazy(() => import("../Reports/detailed"))
pdfMake.vfs = pdfFonts.pdfMake.vfs;

const minutezillaPdfLogoSvg = `<svg version='1.1' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 32 32'><path fill='#ffffff' d='M25.58,27.44c2.68-2.62,4.34-6.28,4.34-10.33c0-7.99-6.47-14.46-14.46-14.46C7.47,2.66,1,9.13,1,17.12c0,4.04,1.66,7.7,4.34,10.33l-1.01,1.01c-0.64,0.64-0.64,1.69,0,2.34c0.64,0.64,1.69,0.64,2.34,0l1.3-1.3c2.19,1.33,4.75,2.09,7.5,2.09c2.74,0,5.31-0.76,7.5-2.09l1.3,1.3c0.64,0.64,1.69,0.64,2.34,0c0.64-0.64,0.64-1.69,0-2.34L25.58,27.44z M15.46,29.33c-6.51,0-11.79-5.28-11.79-11.79S8.95,5.75,15.46,5.75s11.79,5.28,11.79,11.79C27.26,24.05,21.97,29.33,15.46,29.33z' /><path fill='#ffffff' d='M16.25,16.44l-0.41-8.48h-0.37l-0.41,8.48c-0.29,0.19-0.48,0.52-0.48,0.9c0,0.6,0.48,1.08,1.08,1.08c0.53,0,0.97-0.38,1.06-0.89h8.59v-0.18v-0.2h-8.59C16.66,16.85,16.49,16.6,16.25,16.44L16.25,16.44z' /><path fill='#ffffff' d='M15.46,0.34c-2.41,0-4.56,1.13-5.93,2.89c1.83-0.76,3.83-1.18,5.93-1.18s4.11,0.42,5.93,1.18C20.02,1.47,17.87,0.34,15.46,0.34L15.46,0.34z' /></svg>`;

export default function Reports() {
  const { i18n: reportI18n } = useTranslation();
  const auth = useSelector((state) => state.auth);
  const canViewProjectDetail = auth.workspace_role === "ADMIN" || auth.workspace_role === "MANAGER";
  const history = useNavigate();
  const [dates, setDate] = useState([]);
  const [times, setTime] = useState([]);
  const [projectName, setProjectName] = useState([]);
  const [projectTime, setProjectTime] = useState([]);
  const [projectColor, setProjectcolor] = useState([]);
  const [projectArray, setProjectArray] = useState([]);
  const [clockedTime, setClockedTime] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  const [clientDD, openClientDD] = useState(false);
  const [projectDD, openProjectDD] = useState(false);
  const [tagDD, openTagDD] = useState(false);
  const [userDD, openUserDD] = useState(false);
  const [clientList, setClientList] = useState([]);
  const [selectedClients, setSelectedClients] = useState([]);
  const [clientTerm, setClientTerm] = useState("");
  const [projectTerm, setProjectTerm] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [selectedProjects, setSelectedProjects] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [selectedTags, setSelectedTags] = useState([]);
  const [show, setShow] = useState(false);
  const [downloadDDOpen, setDownloadDDOpen] = useState(false);
  const [usertimeList, setUsertimeList] = useState([]);
  const [workspaceData, setWorkspaceData] = useState({ title: "", id: "" });
  const [sortProjectState, setSortProjectState] = useState(false);
  const [sortDuration, setSortDuration] = useState(false);
  const [tab, setTab] = useState(1);
  const [activePeriod, setActivePeriod] = useState('week');
  const [detailedList, setList] = useState([]);
  const [sortDetailList, setSortDetailList] = useState(false);
  const [teamList, setTeamList] = useState([]);
  const [selectedUsers, setSelectedusers] = useState([]);
  const [user_id, setUserId] = useState(0);
  const [is_viewer, setViewer] = useState(false);
  const [timeDurationFormat, setTimeDurationFormat] = useState("");
  const [timeFormat, setTimeFormat] = useState("");
  const [dateFormat, setDateFormat] = useState("");
  const [firstDayOfWeek, setFirstday] = useState(0);
  const [overviewRangeMode, setOverviewRangeMode] = useState('month');
  const [overviewContributionFilter, setOverviewContributionFilter] = useState('all');
  const [overviewMonthDate, setOverviewMonthDate] = useState(startOfMonth(new Date()));
  const [overviewDateRange, setOverviewDateRange] = useState([
    {
      startDate: startOfMonth(new Date()),
      endDate: endOfMonth(new Date()),
      key: "selection",
    },
  ]);
  const [overviewDateMenuOpen, setOverviewDateMenuOpen] = useState(false);
  const [contributionDateMenuOpen, setContributionDateMenuOpen] = useState(false);
  const [overviewData, setOverviewData] = useState(null);
  const [overviewLoading, setOverviewLoading] = useState(false);
  const [overviewError, setOverviewError] = useState('');
  const [isTimeRounding, setTimeRounding] = useState(false);
  const [roundingTo, setRoundingTo] = useState("");
  const [roundingDuration, setRoundingDuration] = useState("");
  const [totalTime, setTotalTime] = useState({
    hours: "00",
    minutes: "00",
    seconds: "00",
  });
  moment.updateLocale('en', {
    week: {
      dow : auth.user_properties !== null &&
        auth.user_properties !== undefined ? auth.user_properties.firstDayOfWeek : 0, // Monday is the first day of the week.
    }
  });
  const [state, setState] = useState([
    {
      startDate: startOfWeek(new Date(),{weekStartsOn: auth.user_properties !== null &&
        auth.user_properties !== undefined ? auth.user_properties.firstDayOfWeek : 0}),
      endDate: endOfWeek(new Date(),{weekStartsOn: auth.user_properties !== null &&
        auth.user_properties !== undefined ? auth.user_properties.firstDayOfWeek : 0}),
      key: "selection",
    },
  ]);
  const [showDate,setShowDate] = useState();
  const chart = useRef(null);
  const overviewDateMenuRef = useRef(null);
  const contributionDateMenuRef = useRef(null);
  const isOverviewPrivileged =
    auth.is_workspace_admin === 1 ||
    auth.workspace_role === 'ADMIN' ||
    auth.workspace_role === 'MANAGER';

  const formatOverviewDuration = (ms) => {
    const totalMinutes = Math.round((Number(ms) || 0) / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    if (hours <= 0) return `${minutes}m`;
    return `${hours}h ${String(minutes).padStart(2, '0')}m`;
  };

  const overviewFallbackData = useMemo(() => {
    if (!Array.isArray(usertimeList) || usertimeList.length === 0) return null;

    let tracked_ms = 0;
    let billable_ms = 0;
    let billable_entries = 0;
    const billableUsers = new Set();

    usertimeList.forEach((entry) => {
      const durationMs = Number(entry.timerTime) || 0;
      const isBillable = Number(entry.is_billable) === 1;

      tracked_ms += durationMs;
      if (isBillable) {
        billable_ms += durationMs;
        billable_entries += 1;
        if (entry.user_id != null) billableUsers.add(entry.user_id);
      }
    });

    const billable_percent = tracked_ms > 0
      ? Math.round((billable_ms / tracked_ms) * 1000) / 10
      : 0;

    return {
      employees: teamList.length || billableUsers.size,
      total_entries: usertimeList.length,
      tracked_ms,
      billable_ms,
      non_billable_ms: Math.max(tracked_ms - billable_ms, 0),
      billable_percent,
      billable_entries,
      billable_employees: billableUsers.size,
      billable_only: false,
      isFallback: true,
    };
  }, [teamList.length, usertimeList]);

  const overviewFallbackContributions = useMemo(() => {
    if (!Array.isArray(teamList) || teamList.length === 0) return [];

    return teamList.map((member) => {
      const uid = Number(member.user_id || member.id);
      const name = member.name || [member.first_name, member.last_name].filter(Boolean).join(' ').trim() || member.email || 'Unknown';

      return {
        user_id: uid,
        name,
        email: member.email || '',
        workspace_role: member.workspace_role || '',
        tracked_ms: 0,
        billable_ms: 0,
        non_billable_ms: 0,
        entries: 0,
        billable_percent: 0,
      };
    });
  }, [teamList]);

  const buildOverviewRange = (period, value = new Date()) => {
    const weekStartsOn = auth.user_properties !== null && auth.user_properties !== undefined
      ? auth.user_properties.firstDayOfWeek
      : firstDayOfWeek;
    const now = value instanceof Date && !Number.isNaN(value.getTime()) ? value : new Date();
    const start = period === 'month'
      ? startOfMonth(now)
      : period === 'range'
        ? startOfDay((value && value.startDate) instanceof Date && !Number.isNaN(value.startDate.getTime())
          ? value.startDate
          : now)
        : startOfWeek(subDays(now, 83), { weekStartsOn });
    const end = period === 'month'
      ? endOfMonth(now)
      : period === 'range'
        ? endOfDay((value && value.endDate) instanceof Date && !Number.isNaN(value.endDate.getTime())
          ? value.endDate
          : (value && value.startDate) instanceof Date && !Number.isNaN(value.startDate.getTime())
            ? value.startDate
            : now)
        : endOfWeek(now, { weekStartsOn });
    return {
      startUnix: Math.floor(start.getTime() / 1000),
      endUnix: Math.floor(end.getTime() / 1000),
    };
  };

  const overviewRangeLabel = useMemo(() => {
    if (overviewRangeMode === 'range') {
      const startDate = overviewDateRange?.[0]?.startDate || null;
      const endDate = overviewDateRange?.[0]?.endDate || startDate;
      if (!startDate) return tr("Select date range");
      if (endDate) {
        return `${format(startDate, 'PP', { locale: getLocale() === 'de-DE' ? deDateLocale : enDateLocale })} - ${format(endDate, 'PP', { locale: getLocale() === 'de-DE' ? deDateLocale : enDateLocale })}`;
      }
      return format(startDate, 'PP', { locale: getLocale() === 'de-DE' ? deDateLocale : enDateLocale });
    }

    return format(overviewMonthDate || new Date(), 'MMMM yyyy', { locale: getLocale() === 'de-DE' ? deDateLocale : enDateLocale });
  }, [overviewDateRange, overviewMonthDate, overviewRangeMode, reportI18n.resolvedLanguage]);

  const overviewTrendSeries = useMemo(() => {
    const source = overviewData || overviewFallbackData;
    const weekly = Array.isArray(source?.weekly_breakdown) && source.weekly_breakdown.length > 0
      ? source.weekly_breakdown
      : [];

    return weekly.map((bucket) => ({
      ...bucket,
      tracked_hours: Number(bucket.tracked_ms || 0) / 3600000,
      billable_hours: Number(bucket.billable_ms || 0) / 3600000,
      non_billable_hours: Number(bucket.non_billable_ms || 0) / 3600000,
    }));
  }, [overviewData, overviewFallbackData]);

  const overviewEmployeeRows = useMemo(() => {
    const metricRows = Array.isArray(overviewData?.employee_breakdown) && overviewData.employee_breakdown.length > 0
      ? overviewData.employee_breakdown
      : overviewFallbackContributions;

    const merged = new Map();

    overviewFallbackContributions.forEach((member) => {
      const uid = Number(member.user_id || member.id);
      merged.set(uid, {
        ...member,
        user_id: uid || member.user_id || member.id,
        name: member.name || [member.first_name, member.last_name].filter(Boolean).join(' ').trim() || member.email || 'Unknown',
        tracked_ms: 0,
        billable_ms: 0,
        non_billable_ms: 0,
        entries: 0,
        billable_percent: 0,
      });
    });

    metricRows.forEach((row) => {
      const uid = Number(row.user_id || row.id);
      const existing = merged.get(uid) || {};
      const tracked_ms = Number(row.tracked_ms) || 0;
      const billable_ms = Number(row.billable_ms) || 0;
      merged.set(uid, {
        ...existing,
        ...row,
        user_id: uid || row.user_id || row.id,
        name: row.name || existing.name || [row.first_name, row.last_name].filter(Boolean).join(' ').trim() || row.email || existing.email || 'Unknown',
        email: row.email || existing.email || '',
        workspace_role: row.workspace_role || existing.workspace_role || '',
        tracked_ms,
        billable_ms,
        non_billable_ms: Number(row.non_billable_ms) || Math.max(tracked_ms - billable_ms, 0),
        entries: Number(row.entries) || 0,
        billable_percent: Number(row.billable_percent) || (tracked_ms > 0 ? Math.round((billable_ms / tracked_ms) * 1000) / 10 : 0),
      });
    });

    return Array.from(merged.values()).map((row) => ({
      ...row,
      user_id: Number(row.user_id) || row.user_id,
      name: row.name || [row.first_name, row.last_name].filter(Boolean).join(' ').trim() || row.email || 'Unknown',
      tracked_ms: Number(row.tracked_ms) || 0,
      billable_ms: Number(row.billable_ms) || 0,
      non_billable_ms: Number(row.non_billable_ms) || Math.max((Number(row.tracked_ms) || 0) - (Number(row.billable_ms) || 0), 0),
      entries: Number(row.entries) || 0,
      billable_percent: Number(row.billable_percent) || 0,
    }));
  }, [overviewData, overviewFallbackContributions]);

  const overviewContributionRows = useMemo(() => {
    const normalized = overviewEmployeeRows.map((row) => {
      const tracked_ms = Number(row.tracked_ms) || 0;
      const billable_ms = Number(row.billable_ms) || 0;
      const entries = Number(row.entries) || 0;
      const billable_percent = tracked_ms > 0 ? Math.round((billable_ms / tracked_ms) * 1000) / 10 : 0;

      return {
        ...row,
        tracked_ms,
        billable_ms,
        non_billable_ms: Math.max(tracked_ms - billable_ms, 0),
        entries,
        billable_percent,
        name: row.name || [row.first_name, row.last_name].filter(Boolean).join(' ').trim() || row.email || 'Unknown',
      };
    });

    const primaryMetric = (row) => {
      if (overviewContributionFilter === 'billable') return row.billable_ms;
      if (overviewContributionFilter === 'non_billable') return row.non_billable_ms;
      return row.tracked_ms;
    };

    const sorted = [...normalized].sort((a, b) => primaryMetric(b) - primaryMetric(a) || b.tracked_ms - a.tracked_ms || b.billable_ms - a.billable_ms || a.name.localeCompare(b.name));
    if (overviewContributionFilter === 'billable') return sorted.filter((r) => r.billable_ms > 0);
    if (overviewContributionFilter === 'non_billable') return sorted.filter((r) => r.non_billable_ms > 0);
    return sorted;
  }, [overviewContributionFilter, overviewEmployeeRows]);

  const overviewContributionRankedRows = useMemo(() => {
    return overviewContributionRows.map((row, index, arr) => {
      const total = arr.length;
      const rank = index + 1;
      const contribution_metric_ms = overviewContributionFilter === 'billable'
        ? row.billable_ms
        : overviewContributionFilter === 'non_billable'
          ? row.non_billable_ms
          : row.tracked_ms;
      const hasContribution = contribution_metric_ms > 0;
      const isLeader = rank === 1 && hasContribution;
      const isTop = rank <= 3 && hasContribution;
      const isLow = total > 3 && !isTop && rank > total - 3;
      return {
        ...row,
        rank,
        contribution_metric_ms,
        isLeader,
        isTop,
        isLow,
      };
    });
  }, [overviewContributionFilter, overviewContributionRows]);

  const overviewContributionMetricLabel = useMemo(() => {
    if (overviewContributionFilter === 'billable') return tr("Billable Hours");
    if (overviewContributionFilter === 'non_billable') return tr("Non-billable Hours");
    return tr("Total Hours");
  }, [overviewContributionFilter]);

  const overviewContributionGridTemplate = useMemo(() => {
    return 'minmax(220px, 1.2fr) minmax(120px, 0.7fr) minmax(280px, 1.4fr) minmax(90px, 0.6fr) minmax(140px, 0.8fr)';
  }, []);

  const overviewChartData = useMemo(() => ({
    labels: overviewTrendSeries.map((bucket) => bucket.label),
    datasets: [
      {
        get label() { return tr("Non-billable"); },
        data: overviewTrendSeries.map((bucket) => bucket.non_billable_hours),
        backgroundColor: 'rgba(214, 232, 222, 0.95)',
        borderColor: 'rgba(214, 232, 222, 1)',
        borderWidth: 1,
      },
      {
        get label() { return tr("Billable"); },
        data: overviewTrendSeries.map((bucket) => bucket.billable_hours),
        backgroundColor: 'rgba(75, 200, 0, 0.75)',
        borderColor: 'rgba(75, 200, 0, 0.95)',
        borderWidth: 1,
      },
    ],
  }), [overviewTrendSeries]);

  const overviewChartOptions = useMemo(() => ({
    responsive: true,
    maintainAspectRatio: false,
    legend: { display: false },
    tooltips: {
      enabled: false,
      external: customTooltip,
    },
    scales: {
      xAxes: [{ stacked: true, gridLines: { display: false }, ticks: { fontSize: 10, maxRotation: 0, minRotation: 0 } }],
      yAxes: [{ stacked: true, ticks: { beginAtZero: true } }],
    },
  }), []);

  useEffect(() => {
    const handleDocumentClick = (event) => {
      if (
        (overviewDateMenuRef.current && overviewDateMenuRef.current.contains(event.target)) ||
        (contributionDateMenuRef.current && contributionDateMenuRef.current.contains(event.target))
      ) {
        return;
      }
      openProjectDD(false);
      openClientDD(false);
      openTagDD(false);
      setDownloadDDOpen(false);
      openUserDD(false);
      setOverviewDateMenuOpen(false);
      setContributionDateMenuOpen(false);
    };

    document.addEventListener("click", handleDocumentClick, true);
    if(auth.user_properties !== null &&
      auth.user_properties !== undefined) {
        let timeZone = auth.user_properties.timeZone;
        if(timeZone === "" || timeZone === null || timeZone === undefined) {
          moment.tz.setDefault();
        }
        else {
          timeZone = timeZone.split(' ')[0];
          moment.tz.setDefault(timeZone)
        }
        let m1 = moment();
        let dd = m1.date();
        let MM = m1.month();
        let yy = m1.year();

        let m = moment({ year :yy, month :MM, day :dd})._d;
        setShowDate(m);
        if(auth.user_id !== null && auth.user_id !== undefined) {
          let user_id = atob(auth.user_id);
          setUserId(parseInt(user_id))
          handleUserCheck(parseInt(user_id));
        }
        //getGraph([parseInt(user_id)]);
        setTimeDurationFormat(auth.user_properties.timeDurationFormat.split(' ')[0]);
        setTimeFormat(alterTimeFormat(auth.user_properties.timeFormat));
        setDateFormat(auth.user_properties.dateFormat);
        setFirstday(auth.user_properties.firstDayOfWeek);
      }
      else {
        moment.tz.setDefault();
        let m1 = moment();
        let dd = m1.date();
        let MM = m1.month();
        let yy = m1.year();

        let m = moment({ year :yy, month :MM, day :dd})._d;
        setShowDate(m);
        if(auth.user_id !== null && auth.user_id !== undefined) {
          let user_id = atob(auth.user_id);
          setUserId(parseInt(user_id))
          handleUserCheck(parseInt(user_id));
        }
        setTimeDurationFormat("Improved");
        setTimeFormat("hh:mm A");
        setDateFormat("DD-MM-YYYY");
        setFirstday(0);
      }

    getClientList();
    getProjectList();
    getTagList();
    getWorkspaceInfo();
    //detailedReport([parseInt(user_id)]);
    getTeamList();

    return () => {
      document.removeEventListener("click", handleDocumentClick, true);
    };
  }, []);

  useEffect(() => {
    if (!isOverviewPrivileged || !auth.workspace_id) return;

    const loadWorkspaceOverview = async () => {
      setOverviewLoading(true);
      setOverviewError('');
      try {
        const { startUnix, endUnix } = overviewRangeMode === 'range'
          ? buildOverviewRange('range', overviewDateRange?.[0] || new Date())
          : buildOverviewRange('month', overviewMonthDate || new Date());
        const params = new URLSearchParams({
          workspace_id: String(auth.workspace_id),
          start_unix: String(startUnix),
          end_unix: String(endUnix),
          billable_only: '0',
        });

        const res = await axios.get(`/api/report/workspace_overview?${params.toString()}`, {
          withCredentials: true,
          headers: { 'Content-Type': 'application/json' },
        });

        setOverviewData(res.data);
      } catch (err) {
        setOverviewError('Failed to load workspace overview.');
      } finally {
        setOverviewLoading(false);
      }
    };

    loadWorkspaceOverview();
  }, [auth.workspace_id, isOverviewPrivileged, overviewDateRange, overviewMonthDate, overviewRangeMode]);

  const getWorkspaceInfo = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post(
        "/api/workspace/listbyworkspaceid",
        body,
        config
      );
      if (res.status === 200) {
        res.data.results.map((item)=> {
          if(Number(item.id) === Number(workspace_id)) {
            if(item.is_time_rounding === 1) {
              setTimeRounding(true);
              setRoundingTo(item.rounding_to);
              setRoundingDuration(item.rounding_duration);
            }
              setWorkspaceData({
              title: item.title,
              id: item.id,
              });
              if(item.is_sole_team_viewer === 1) {
                if(auth.is_workspace_admin === 1 || auth.workspace_role === 'ADMIN' || auth.workspace_role === 'MANAGER') {
                  setViewer(true);
                }
                else {
                  setViewer(false);
                }
              }
              else {
                setViewer(true);
              }
          }
      })
      }
    } catch (err) {
      console.log(err.response);
      return err.response;
    }
  };

  const currentWorkspaceData = async () => {
    try{
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/workspace/listbyworkspaceid", body, config);
      if(res.status === 200) {
        let roundingData;
        res.data.results.map((item)=> {
          if(Number(item.id) === Number(workspace_id)) {
            roundingData = {
              is_time_rounding: item.is_time_rounding,
              rounding_duration: item.rounding_duration,
              rounding_to: item.rounding_to
            }
          }
        });
        return roundingData;
      }
    }
    catch(err) {
      console.log(err.response);
      return err.response;
    }
  }

  const getTeamList = async (modenumber) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;

      const body = JSON.stringify({  workspace_id });
      let res = await axios.post("/api/report/team_list", body, config);
      if (res.status === 200) {
        setTeamList(res.data.results);
      }
    } catch (err) {
      if (err.response) {
        console.log(err.response);
      }
    }
};

  const getGraph = async (uu, cc, pp, tt, s, le) => {
    let curr = new Date();
    let first, last, ss, start, end, ll, arr, i;

    if (s !== null && s !== undefined && le !== null && le !== undefined) {
      let dd1 = s.getDate();
      let dd2 = le.getDate();
      let MM1 = s.getMonth();
      let MM2 = le.getMonth();
      let yy1 = s.getFullYear();
      let yy2 = le.getFullYear();

      let start1 = moment({ year :yy1, month :MM1, day :dd1});
      start = start1.format("YYYY-MM-DD");
      first = start1.date();
      let end1 = moment({ year :yy2, month :MM2, day :dd2});
      end = end1.format("YYYY-MM-DD");
      last = end1.date();
      i = first - last;
      //console.log(first,last,i,start,end)
    } else {
      let dd1 = state[0].startDate.getDate();
      let dd2 = state[0].endDate.getDate();
      let MM1 = state[0].startDate.getMonth();
      let MM2 = state[0].endDate.getMonth();
      let yy1 = state[0].startDate.getFullYear();
      let yy2 =state[0].endDate.getFullYear();

      let start1 = moment({ year :yy1, month :MM1, day :dd1});
      start = start1.format("YYYY-MM-DD");
      first = start1.date();
      let end1 = moment({ year :yy2, month :MM2, day :dd2});
      end = end1.format("YYYY-MM-DD");
      last = end1.date();
      i = first - last;
      //console.log(first,last,i,start,end)
    }

    if (i < 0 || getMonth(parseISO(start)) !== getMonth(parseISO(end))) {
      arr = eachDayOfInterval({ start: new Date(start), end: new Date(end) });
    } else {
      arr = eachDayOfInterval({ start: new Date(start), end: new Date(end) });
    }
    //console.log(arr);
    let l = arr.length;
    let x;
    let newArr = [];
    for (x = 0; x < l; x++) {
      newArr.push(moment(arr[x]).format("M/D"));
    }
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      let clients = cc !== null && cc !== undefined ? cc : "";
      let projects = pp !== null && pp !== undefined ? pp : "";
      let tags = tt !== null && tt !== undefined ? tt : "";
      let users = uu !== null && uu !== undefined ? uu : [user_id];
      let range = l;

      const body = JSON.stringify({
        start,
        end,
        workspace_id,
        clients,
        projects,
        tags,
        range,
        users
      });

      //console.log(body);
      let res = await axios.post("/api/report/week_data", body, config);
      if (res.status === 200) {
        let roundingData1 = await currentWorkspaceData() || {};
        let rounding_duration,rounding_to;
        if(roundingData1.is_time_rounding === 1) {
          let arr1 = roundingData1.rounding_duration.split(' ');
          let arr2 = roundingData1.rounding_to.split(' ');
          if(arr1[1].charAt(0) === 'm') {
            rounding_duration = parseInt(arr1[0]);
          }
          else if(arr1[1].charAt(0) === 'h') {
            rounding_duration = parseInt(arr1[0])*60;
          }
          rounding_to = arr2[1];
        }
        let roundingData = {
          is_time_rounding : roundingData1.is_time_rounding,
          rounding_duration,
          rounding_to
        }
        // get total time spent
        getClockedTime(res.data.barGraphData,start,end,roundingData);

        getUserTimeList(res.data.usertimeList,start,end,roundingData);

        let len = newArr.length;
        if (len > 31 && len < 183) {

          let arrWeek = eachWeekOfInterval({
            start: new Date(start),
            end: new Date(end),
          });
          /**get time and weeks data for displaying bar graph */
          weekGraphFunction(res.data.barGraphData,arrWeek,roundingData)
        } else if (len >= 183) {
          let arrMonth = eachMonthOfInterval({
            start: new Date(start),
            end: new Date(end),
          });
          /**get time and months data for displaying bar graph */
          monthGraphFunction(res.data.barGraphData,arrMonth,roundingData);
        } else {
          /**get time and days data for displaying bar graph */
          dayGraphFunction(res.data.barGraphData,newArr,roundingData);
        }
        /**get data for project list and doughnut graph */
        getProjectGraph(res.data.project,start,end,roundingData);

      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const getProjectGraph = async (data,start,end,roundingData) => {
    let newProjectArray = [];
    let projectNameArray = [];
    let projectColor = [];
    let projectId = [];
    await data.map(item => {
      if(moment(item.timer_start,'X').isBetween(start,end,'days',[])) {
        newProjectArray.push(item);
        if(item.project_id !== "" && item.project_id !== null && item.project_id !== undefined) {
          if(!projectNameArray.includes(item.project_name)) {
            projectNameArray.push(item.project_name);
            projectColor.push(item.project_color);
            projectId.push(item.project_id);
          }
        }
        else if(!projectNameArray.includes("Without Project")) {
          projectNameArray.push("Without Project");
          projectColor.push("#13D1FC");
          projectId.push(0);
        }
      }
    })

    let len = projectNameArray.length;
    let i;
    let timeProjectArrayGraph = [];
    let originalProjectArray = [];
    let timeOfEachProject = [];
    for(i=0;i<len;i++) {
      let totalTime = 0;
      let totalTime2 = "00:00:00";
      newProjectArray.map(item => {
        if(projectNameArray[i] === "Without Project") {
          if(item.project_name === "" || item.project_name === null || item.project_name === undefined) {
            //totalTime = totalTime + parseInt(item.timerTime);
            if(roundingData.is_time_rounding === 1) {
              let t = millisecondsToTime(parseInt(item.timerTime));
              let t1 =  roundingFunction(t,roundingData.rounding_duration,roundingData.rounding_to);
              totalTime2 = sumOfTImeDuration(t1,totalTime2);//moment.duration(totalTime2).add(t1);
            } else {
              totalTime = totalTime + parseInt(item.timerTime);
            }
          }
        }
        else {
          if(projectNameArray[i] === item.project_name) {
            //totalTime = totalTime + parseInt(item.timerTime);
            if(roundingData.is_time_rounding === 1) {
              let t = millisecondsToTime(parseInt(item.timerTime));
              let t1 =  roundingFunction(t,roundingData.rounding_duration,roundingData.rounding_to);
              totalTime2 = sumOfTImeDuration(t1,totalTime2);//moment.duration(totalTime2).add(t1);
            } else {
              totalTime = totalTime + parseInt(item.timerTime);
            }
          }
        }
      });
      let time,timeInHour;
      if(roundingData.is_time_rounding === 1) {
        let arr = totalTime2.split(':');
        let hours = arr[0];
        let minutes = arr[1];
        let seconds = arr[2];
        //setClockedTime({ hours: hours, minutes: minutes, seconds: seconds });
        time = `${hours}:${minutes}:${seconds}`;
        timeOfEachProject.push(time);
        timeInHour = parseInt(hours) + (parseInt(minutes)/60) + (parseInt(seconds)/3600);
        timeProjectArrayGraph.push(timeInHour.toFixed(2));
      }
      else {
        time = millisecondsToTime(totalTime);
        timeOfEachProject.push(time);
        timeInHour = (totalTime/3600000).toFixed(2);
        timeProjectArrayGraph.push(timeInHour);
      }
    }
    let time_duration_format = "Improved";
    if(auth.user_properties !== null &&
      auth.user_properties !== undefined) {
        time_duration_format = auth.user_properties.timeDurationFormat.split(' ')[0];
    }
    for(i=0;i<len;i++) {
      originalProjectArray.push({
        project_name: capitalizeFirstLetter(projectNameArray[i]),
        time: alterDisplayTime(timeOfEachProject[i],time_duration_format),
        projectColor: projectColor[i],
        project_id:projectId[i],
        displayTime : timeOfEachProject[i]
      })
    }
    //console.log(originalProjectArray)
    setProjectArray(originalProjectArray);
    setProjectName(projectNameArray);
    setProjectTime(timeProjectArrayGraph);
    setProjectcolor(projectColor);
  }

  const millisecondsToTime =  (milliseconds) => {
    if (!milliseconds || isNaN(milliseconds)) return "00:00:00";
    let seconds = (milliseconds / 1000).toFixed();
    // 2- Extract hours:
    let hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
    if(parseInt(hours/10) === 0) {
      hours = ("0" + hours);
    }
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // 3- Extract minutes:
    let minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    seconds = ("0" + (seconds % 60)).slice(-2);
    return `${hours}:${minutes}:${seconds}`;
  }
  const getUserTimeList = async (data,start,end,roundingData) => {
    let newArray = [];
      let len = data.length;
      let uniq = [];
      await data.map((item, i) => {
        if(moment(item.timer_start,'X').isBetween(start,end,'days',[])) {
          newArray = [...newArray,moment(item.timer_start,"X").format("MM/DD/YYYY")]
        }
      })
      uniq = [...new Set(newArray)];
      //console.log(uniq,start,end)
      let i = 0;
      let l = uniq.length;
      let time_duration_format = "Improved";
      let date_format = "DD-MM-YYYY";
      if(auth.user_properties !== null &&
        auth.user_properties !== undefined) {
          time_duration_format = auth.user_properties.timeDurationFormat.split(' ')[0];
          date_format = auth.user_properties.dateFormat;
      }
      let taskList =  [];
      for(i=0;i<l;i++) {
         data.map((item,index) => {
             if(uniq[i] === moment(item.timer_start,"X").format("MM/DD/YYYY")) {
               let time;
              if(roundingData.is_time_rounding === 1) {
                let t1 = item.displayTime ? roundingFunction(item.displayTime,roundingData.rounding_duration,roundingData.rounding_to) : item.displayTime;
                time = alterDisplayTime(t1, time_duration_format);
              }
              else {
                time = alterDisplayTime(item.displayTime, time_duration_format);
              }
                 taskList.push({
                          //date : uniq[i],
                          date: `${moment.unix(item.timer_start)
                            .format(date_format)}`,
                          displayTime: time,
                          timer_id : item.timer_id,
                          title: capitalizeFirstLetter(item.title),
                          project_id: item.project_id,
                          project:capitalizeFirstLetter(item.project_name),
                          project_color : item.project_color,
                          user_id: item.user_id,
                          client_id: item.client_id,
                          client: item.client_name,
                          workspace_id: item.workspace_id,
                          tag_id:item.tag_id,
                          tag_title: item.tag_title,
                          tagcolor : item.tagcolor,
                          timerStart: item.timerStart,
                          timerTime: item.timerTime,
                          //displayTime: item.displayTime,
                          isStop: item.isStop,
                          is_billable:item.is_billable,
                          crdate: item.crdate,
                          modified_date: item.modified_date,
                          timer_start : item.timer_start,
                          timer_end : item.timer_end
                 })
             }
         })
     }
     setUsertimeList(taskList);
  }

  const roundingFunction = (time, minutesToRound,rounding_to) => {
    let [hours, minutes, seconds] = time.split(':');
    hours = parseInt(hours);
    minutes = parseInt(minutes);
    seconds = parseInt(seconds);

    // Convert hours and minutes to time in minutes
    time = (hours * 60) + minutes + (seconds/60);
    let rounded,rHr,rMin;
    if(rounding_to === "up") {
      rounded = Math.ceil(time / minutesToRound) * minutesToRound;
    }
    else if(rounding_to === "down") {
      rounded = Math.floor(time / minutesToRound) * minutesToRound;
    }
    else if(rounding_to === "to") {
      rounded = Math.round(time / minutesToRound) * minutesToRound;
    }
    /*console.log(time,(Math.ceil(time / minutesToRound) * minutesToRound),
    (Math.floor(time / minutesToRound) * minutesToRound),
    (Math.round(time / minutesToRound) * minutesToRound))*/

    rHr = ''+Math.floor(rounded / 60)
    rMin = ''+ rounded % 60
    return rHr.padStart(2, '0')+':'+rMin.padStart(2, '0')+':00'
  }

  const monthGraphFunction = async (data,arrMonth,roundingData) => {
    let j;
    let len = arrMonth.length;
    let monthArray = [];
    let timeArray = [];

    for(j=0;j<len;j++) {
      let totalTime = 0;
      let totalTime2 = "00:00:00";
      let dd = arrMonth[j].getDate();
      let mm = arrMonth[j].getMonth();
      let yy = arrMonth[j].getFullYear();
      let monthMoment = moment({year :yy,month : mm, day : dd});
      let monthName = monthMoment.format('MMM');

      data.map(item => {
        if(moment(item.timer_start,'X').isSame(monthMoment,'month')) {
          //totalTime = totalTime + parseInt(item.timerTime);
          if(roundingData.is_time_rounding === 1) {
            let t = millisecondsToTime(parseInt(item.timerTime));
            let t1 =  roundingFunction(t,roundingData.rounding_duration,roundingData.rounding_to);
            totalTime2 = sumOfTImeDuration(t1,totalTime2);//moment.duration(totalTime2).add(t1);
          } else {
            totalTime = totalTime + parseInt(item.timerTime);
          }
        }
      })
      if(!monthArray.includes(monthName)) {
        monthArray.push(monthName);
        if(totalTime !== 0 || (totalTime2 !== "" && totalTime2 !== undefined && totalTime2 !== null)) {
          if(roundingData.is_time_rounding === 1) {
            let arr = totalTime2.split(':');
            let hours = parseInt(arr[0]);
            let minutes = parseInt(arr[1]);
            let seconds = parseInt(arr[2]);

            let time = hours + (minutes/60) + (seconds/3600);
            time = time.toFixed(4);
            timeArray.push(time);
          }
          else{
            let time = (totalTime/3600000).toFixed(4)
            timeArray.push(time);
          }
        }
        else {
          timeArray.push(0);
        }
      }
    }
    setDate(monthArray);
    setTime(timeArray);
  }

  const weekGraphFunction = async (data,arrWeek,roundingData) => {
    //console.log(data,arrWeek);
    let j;
    let len = arrWeek.length;
    let weekArray = [];
    let timeArray = [];
    for(j=0;j<len;j++) {
      let week = moment(arrWeek[j])._d;
      let dd = arrWeek[j].getDate();
      let mm = arrWeek[j].getMonth();
      let yy = arrWeek[j].getFullYear()
      //console.log(arrWeek[j].getDate(),arrWeek[j].getMonth(),arrWeek[j].getFullYear());
      let weekNumber = `week ${moment(week).format("ww")}`
      let totalTime = 0;
      let totalTime2 = "00:00:00";
      let weekMoment = moment({year :yy,month : mm, day : dd});
      data.map(item => {
        if(moment(item.timer_start,'X').isSame(weekMoment,'week')) {
          //totalTime = totalTime + parseInt(item.timerTime);
          if(roundingData.is_time_rounding === 1) {
            let t = millisecondsToTime(parseInt(item.timerTime));
            let t1 =  roundingFunction(t,roundingData.rounding_duration,roundingData.rounding_to);
            totalTime2 = sumOfTImeDuration(t1,totalTime2);//moment.duration(totalTime2).add(t1);
          } else {
            totalTime = totalTime + parseInt(item.timerTime);
          }
        }
      })
      if(!weekArray.includes(weekNumber)) {
        weekArray.push(weekNumber);
        if(totalTime !== 0 || (totalTime2 !== "" && totalTime2 !== undefined && totalTime2 !== null)) {
          if(roundingData.is_time_rounding === 1) {
            let arr = totalTime2.split(':');
            let hours = parseInt(arr[0]);
            let minutes = parseInt(arr[1]);
            let seconds = parseInt(arr[2]);

            let time = hours + (minutes/60) + (seconds/3600);
            time = time.toFixed(4);
            timeArray.push(time);
          }
          else{
            let time = (totalTime/3600000).toFixed(4)
            timeArray.push(time);
          }
        }
        else {
          timeArray.push(0);
        }
      }
    }
    setDate(weekArray);
    setTime(timeArray);
  }
  const dayGraphFunction = async (data,newArr,roundingData) => {
    //console.log(data,newArr)
    let len = newArr.length;
    let j;
    let dateArray = [];
    let timeArray = [];
    let time_duration_format = "Improved";
    let dateformat = "DD-MM-YYYY";
    if(auth.user_properties !== null &&
      auth.user_properties !== undefined) {
        time_duration_format = auth.user_properties.timeDurationFormat.split(' ')[0];
        if(auth.user_properties.dateFormat.slice(0,2) === "YY") {
          dateformat = auth.user_properties.dateFormat.slice(-5)
        }
        else {
          dateformat = auth.user_properties.dateFormat.slice(0,5)
        }
    }

    for (j = 0; j < len; j++) {
      let totalTime = 0;
      let totalTime2 = "00:00:00";
      data.map((item) => {
        if (newArr[j] === moment(item.timer_start,"X").format("M/D") ) {
          //console.log(moment(item.timer_start,"X").format("M/D"),(item.timerTime/3600000).toFixed(4))
          //totalTime = totalTime + parseInt(item.timerTime);
          if(roundingData.is_time_rounding === 1) {
            let t = millisecondsToTime(parseInt(item.timerTime));
            let t1 =  roundingFunction(t,roundingData.rounding_duration,roundingData.rounding_to);
            totalTime2 =  sumOfTImeDuration(t1,totalTime2);//moment.duration(totalTime2).add(t1);
            //console.log(t,t1,totalTime2)
          } else {
            totalTime = totalTime + parseInt(item.timerTime);
          }
        }
      });
      let date = newArr[j].split('/');
          let mm = date[0] - 1;
          let dd = date[1];
      if (!dateArray.includes(moment({month : mm, day : dd}).format(dateformat))) {
        dateArray.push(moment({month : mm, day : dd}).format(dateformat));
        if(totalTime !== 0 || (totalTime2 !== "00:00:00" && totalTime2 !== undefined && totalTime2 !== null)) {
          if(roundingData.is_time_rounding === 1) {
            let arr = totalTime2.split(':');
            let hours = parseInt(arr[0]);
            let minutes = parseInt(arr[1]);
            let seconds = parseInt(arr[2]);

            let time = hours + (minutes/60) + (seconds/3600);
            time = time.toFixed(4);
            timeArray.push(time);
          }
          else{
            let time = (totalTime/3600000).toFixed(4)
            timeArray.push(time);
          }
        }
        else {
          timeArray.push(0);
        }
      }
    }
    setDate(dateArray);
    setTime(timeArray);
  }

  const sumOfTImeDuration = (firstTime,secondTime) => {
    let time1 = firstTime;
    let time2 = secondTime;
    //console.log(firstTime,secondTime)
    let splitTime1= time1.split(':');
    let splitTime2= time2.split(':');
    //var splitTime3= time3.split(':');
    let timeInMinutes1 = (parseInt(splitTime1[0]) * 60) + parseInt(splitTime1[1]) + (parseInt(splitTime1[2])/60);
    let timeInMinutes2 = (parseInt(splitTime2[0]) * 60) + parseInt(splitTime2[1]) + (parseInt(splitTime2[2])/60);
    let totalTime = timeInMinutes1 + timeInMinutes2;
    let seconds = totalTime * 60;
    // 2- Extract hours:
    let hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
    if(parseInt(hours/10) === 0) {
      hours = ("0" + hours);
    }
    seconds = seconds % 3600; // seconds remaining after extracting hours
    // 3- Extract minutes:
    let minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
    // 4- Keep only seconds not extracted to minutes:
    seconds = ("0" + (seconds % 60)).slice(-2);
    //console.log('sum of above time= '+hours+':'+minutes+':'+seconds)
    return `${hours}:${minutes}:${seconds}`;

  }

  const getClockedTime = async (data,start,end,roundingData) => {
    let totalTime = 0;
    let totalTime2 = "00:00:00";


    data.map(item => {
      if(moment(item.timer_start,'X').isBetween(start,end,'days',[])) {
        if(roundingData.is_time_rounding === 1) {
          let t = millisecondsToTime(parseInt(item.timerTime));
          let t1 =  roundingFunction(t,roundingData.rounding_duration,roundingData.rounding_to);
          totalTime2 = sumOfTImeDuration(t1,totalTime2);//moment.duration(totalTime2).add(t1);
        } else {
          totalTime = totalTime + parseInt(item.timerTime);
        }
      }
    })
    //console.log(totalTime2,totalTime2.hours(),totalTime2.minutes(),totalTime2.seconds());
    if(roundingData.is_time_rounding === 1) {
      let arr = totalTime2.split(':');
      let hours = arr[0];
      let minutes = arr[1];
      let seconds = arr[2];
      setClockedTime({ hours: hours, minutes: minutes, seconds: seconds });
    }
    else {
        // 1- Convert to seconds:
        let seconds = (totalTime / 1000).toFixed();
        // 2- Extract hours:
        let hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
        if(parseInt(hours/10) === 0) {
          hours = ("0" + hours);
        }
        seconds = seconds % 3600; // seconds remaining after extracting hours
        // 3- Extract minutes:
        let minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
        // 4- Keep only seconds not extracted to minutes:
        seconds = ("0" + (seconds % 60)).slice(-2);
    setClockedTime({ hours: hours, minutes: minutes, seconds: seconds });
    }
  }

  const capitalizeFirstLetter = (string) => {
    if(string !== null && string !== undefined && string !== "") {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }
    else {
      return string;
    }
  }
  const sortProjectArray = () => {
    let array = projectArray;
    let ascendingArray = array.sort(function(a, b){
      let nameA=a.project_name.toLowerCase(), nameB=b.project_name.toLowerCase();
      if (nameA < nameB) //sort string ascending
       return -1;
      if (nameA > nameB)
       return 1;
      return 0; //default return value (no sorting)
     });
     if(sortProjectState === false) {
      setSortProjectState(true);
       setProjectArray([...ascendingArray]);
     }
     else {
       setSortProjectState(false)
      let descendingArray =  ascendingArray.reverse();
       setProjectArray([...descendingArray]);
     }
  }

  const sortDetailedList = (variable) => {
    let array = detailedList;
    let ascendingArray;
    if(variable === "title") {
      ascendingArray = array.sort(function(a, b){
        let nameA=a.title.toLowerCase(), nameB=b.title.toLowerCase();
        if (nameA < nameB) //sort string ascending
         return -1;
        if (nameA > nameB)
         return 1;
        return 0; //default return value (no sorting)
       });
       if(sortDetailList === false) {
        setSortDetailList(true);
        setList([...ascendingArray]);
       }
       else {
        setSortDetailList(false)
        let descendingArray =  ascendingArray.reverse();
        setList([...descendingArray]);
       }
    }
    else if(variable === "time") {
      let elements = detailedList;
      let parsedDates = new Map(
        elements.map(e => [e.timer_start, e])
        );

      elements = elements.map(x => x.timer_start).sort().map(x => parsedDates.get(x))
        if(sortDetailList === false) {
          setSortDetailList(true);
          setList([...elements]);
        }
        else {
          elements.reverse();
          setSortDetailList(false);
          setList([...elements]);
        }
    }
    else if(variable === "duration") {
      let elements = detailedList;
    let sortedList = sortListOnDuration(elements);
        if(sortDetailList === false) {
          setSortDetailList(true);
          setList([...sortedList]);
        }
        else {
          sortedList.reverse();
          setSortDetailList(false);
          setList([...sortedList]);
        }
    }
  }

  const sortListOnDuration = (array) => {
    return array.sort(function (a, b) {
        if (parseInt(a.time.split(":")[0]) - parseInt(b.time.split(":")[0]) === 0) {
            return parseInt(a.time.split(":")[1]) - parseInt(b.time.split(":")[1]);
        } else {
            return parseInt(a.time.split(":")[0]) - parseInt(b.time.split(":")[0]);
        }
    })
}

  const sortProjectDuration = () => {
    let elements1 = projectArray;
      const sortProjectListOnDuration = (array) => {
        return array.sort(function (a, b) {
            if (parseInt(a.displayTime.split(":")[0]) - parseInt(b.displayTime.split(":")[0]) === 0) {
                return parseInt(a.displayTime.split(":")[1]) - parseInt(b.displayTime.split(":")[1]);
            } else {
                return parseInt(a.displayTime.split(":")[0]) - parseInt(b.displayTime.split(":")[0]);
            }
        })
      }
    let elements = sortProjectListOnDuration(elements1);//elements.map(x => x.displayTime).sort().map(x => parsedDates.get(x))
      if(sortDuration === false) {
        setSortDuration(true);
        setProjectArray([...elements]);
      }
      else {
        elements.reverse();
        setSortDuration(false);
        setProjectArray([...elements]);
      }
  }

  const getClientList = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      let searchTerm = clientTerm;
      const body = JSON.stringify({ workspace_id, searchTerm });
      let res = await axios.post("/api/client/search", body, config);
      if (res.status === 200) {
        setClientList(res.data.results);
      }
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const getProjectList = async (modeN, client, term) => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      let is_workspace_admin = auth.is_workspace_admin;
      let mode = modeN;
      let clients =
        client !== undefined && client !== [] && client !== "" ? client : "";

      let searchTerm = projectTerm;
      const body = JSON.stringify({
        is_workspace_admin,
        workspace_id,
        mode,
        clients,
        projectTerm,
      });
      let res = await axios.post("/api/project/list", body, config);
      if (res.status === 200) {
        setProjectList(res.data.results);
      }
    } catch (err) {
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const getTagList = async () => {
    try {
      const config = {
        headers: {
          Authorization: `Bearer ${auth.token}`,
          "Content-Type": "application/json",
        },
      };
      let workspace_id = auth.workspace_id;
      const body = JSON.stringify({ workspace_id });
      let res = await axios.post("/api/tag/list", body, config);
      setTagList(res.data.results);
    } catch (err) {
      console.log(err);
      if (err.response) {
        console.log(err.response);
      }
    }
  };

  const next = async () => {
    let start = state[0].startDate;
    let end = state[0].endDate;
    let diff =
      differenceInCalendarDays(state[0].endDate, state[0].startDate) + 1;
    await setState([
      {
        startDate: addDays(end, 1),
        endDate: addDays(end, diff),
        key: "selection",
      },
    ]);
    let ss = addDays(end, 1);
    let ee = addDays(end, diff);
    getGraph(selectedUsers, selectedClients, selectedProjects, selectedTags, ss, ee);
    detailedReport(selectedUsers, selectedClients, selectedProjects, ss, ee);
  };

  const previous = async () => {
    let start = state[0].startDate;
    let end = state[0].endDate;
    let diff =
      differenceInCalendarDays(state[0].endDate, state[0].startDate) + 1;
    await setState([
      {
        startDate: subDays(start, diff),
        endDate: subDays(start, 1),
        key: "selection",
      },
    ]);
    let ss = subDays(start, diff);
    let ee = subDays(start, 1);
    getGraph(selectedUsers, selectedClients, selectedProjects, selectedTags, ss, ee);
    detailedReport(selectedUsers, selectedClients, selectedProjects, ss, ee);
  };

  const setPeriodRange = (type) => {
    setActivePeriod(type);
    if (type === 'custom') { setShow(true); return; }
    const weekStartsOn = firstDayOfWeek;
    const now = new Date();
    let ss, ee;
    if (type === 'week')       { ss = startOfWeek(now, { weekStartsOn }); ee = endOfWeek(now, { weekStartsOn }); }
    else if (type === '7days') { ss = subDays(now, 6); ee = now; }
    else if (type === 'month') { ss = startOfMonth(now); ee = endOfMonth(now); }
    else if (type === '30days'){ ss = subDays(now, 29); ee = now; }
    else if (type === 'year')  { ss = startOfYear(now); ee = endOfYear(now); }
    setState([{ startDate: ss, endDate: ee, key: 'selection' }]);
    getGraph(selectedUsers, selectedClients, selectedProjects, selectedTags, ss, ee);
    detailedReport(selectedUsers, selectedClients, selectedProjects, ss, ee);
  };

  // Custom tooltip for all charts — must be a regular function so `this` = chart instance
  function customTooltip(tooltipModel) {
    let el = document.getElementById('rp-custom-tooltip');
    if (!el) {
      el = document.createElement('div');
      el.id = 'rp-custom-tooltip';
      document.body.appendChild(el);
    }
    if (tooltipModel.opacity === 0) {
      el.style.opacity = '0';
      return;
    }
    let html = '';
    if (tooltipModel.title) {
      tooltipModel.title.forEach(t => { html += `<div className="rp-tt-title">${t}</div>`; });
    }
    if (tooltipModel.body) {
      tooltipModel.body.forEach((body, i) => {
        const colors = tooltipModel.labelColors[i];
        html += `<div className="rp-tt-row"><span className="rp-tt-dot" style="background:${colors.backgroundColor}"></span>${body.lines[0]}</div>`;
      });
    }
    el.innerHTML = html;
    const canvas = this._chart.canvas;
    const pos = canvas.getBoundingClientRect();
    el.style.left    = (pos.left + tooltipModel.caretX) + 'px';
    el.style.top     = (pos.top  + tooltipModel.caretY - 52) + 'px';
    el.style.opacity = '1';
  }

  // Spotlight hover — dims non-hovered segments; must be regular function so `this` = chart instance
  function spotlightHover(event, activeEls) {
    const ds = this.data.datasets[0];
    if (!Array.isArray(ds.backgroundColor) || ds.backgroundColor.length === 0) return;
    if (!ds._origColors) ds._origColors = [...ds.backgroundColor];
    const orig = ds._origColors;
    if (activeEls.length === 0) {
      ds.backgroundColor = [...orig];
    } else {
      const idx = activeEls[0]._index;
      ds.backgroundColor = orig.map((c, i) =>
        i === idx ? c : (c.length >= 7 ? c.slice(0, 7) + '25' : c + '25')
      );
    }
    this.update();
  }

  const handleProjectTerm = (e) => {
    setProjectTerm(e.target.value);
  };

  const handleClientTerm = (e) => {
    setClientTerm(e.target.value);
  };

  const handleClientCheck = (item) => {
    let newArr = [];
    if (!selectedClients.includes(item)) {
      newArr = [...selectedClients, item];
    } else {
      newArr = selectedClients.filter((a) => a !== item);
    }
    setSelectedClients(newArr);
    getGraph(selectedUsers, newArr, selectedProjects, selectedTags);
    detailedReport(selectedUsers, newArr, selectedProjects);
  };

  const handleProjectCheck = (item) => {
    let newArr = [];
    if (!selectedProjects.includes(item)) {
      newArr = [...selectedProjects, item];
    } else {
      newArr = selectedProjects.filter((a) => a !== item);
    }
    setSelectedProjects(newArr);
    getGraph(selectedUsers, selectedClients, newArr, selectedTags);
    detailedReport(selectedUsers, selectedClients, newArr);
  };

  const handleUserCheck = (item) => {
    let newArr = [];
    if (!selectedUsers.includes(item)) {
      newArr = [...selectedUsers, item];
    } else {
      newArr = selectedUsers.filter((a) => a !== item);
    }
    setSelectedusers(newArr);
    getGraph(newArr,selectedClients, selectedProjects, selectedTags);
    detailedReport(newArr,selectedClients, selectedProjects);
  };

  const handleTagCheck = (item) => {
    let newArr = [];
    if (!selectedTags.includes(item)) {
      newArr = [...selectedTags, item];
    } else {
      newArr = selectedTags.filter((a) => a !== item);
    }
    setSelectedTags(newArr);
    getGraph(selectedUsers, selectedClients, selectedProjects, newArr);
    //detailedReport(selectedUsers, selectedClients, selectedProjects, newArr);
  };

  const selectAllClients = () => {
    setSelectedClients([]);
    let rowState = [];
    clientList.map((item, index) => {
      rowState.push(item.id);
      setSelectedClients(rowState);
    });
    getGraph(selectedUsers, rowState, selectedProjects, selectedTags);
    detailedReport(selectedUsers, rowState, selectedProjects);
  };

  const selectNoClients = () => {
    setSelectedClients([]);
    getGraph(selectedUsers, null, selectedProjects, selectedTags);
    detailedReport(selectedUsers, null, selectedProjects);
  };

  const selectAllProjects = () => {
    setSelectedProjects([]);
    let rowState = [];
    projectList.map((item, index) => {
      rowState.push(item.id);
      setSelectedProjects(rowState);
    });
    getGraph(selectedUsers, selectedClients, rowState, selectedTags);
    detailedReport(selectedUsers, selectedClients, rowState);
  };

  const selectNoProjects = () => {
    setSelectedProjects([]);
    getGraph(selectedUsers, selectedClients, null, selectedTags);
    detailedReport(selectedUsers, selectedClients, null);
  };

  const selectAllTags = () => {
    setSelectedTags([]);
    let rowState = [];
    tagList.map((item, index) => {
      rowState.push(item.id);
      setSelectedTags(rowState);
    });
    getGraph(selectedUsers, selectedClients, selectedProjects, rowState);
    //detailedReport(selectedUsers, selectedClients, selectedProjects, rowState);
  };

  const selectAllUsers = () => {
    setSelectedusers([]);
    let rowState = [];
    teamList.map((item, index) => {
      rowState.push(item.user_id);
      setSelectedusers(rowState);
    });
    getGraph(rowState, selectedClients, selectedProjects, selectedTags);
    detailedReport(rowState, selectedClients, selectedProjects);
  };

  const handleSelect = (item) => {
    //setState([{startDate:item.selection.endDate,endDate:item.selection.startDate,key:item.selection.key}]);
    setState([item.selection]);
    //detailedReport(selectedUsers, selectedClients, selectedProjects);
  };

  const handleOverviewDateRangeSelect = (item) => {
    if (item?.selection) setOverviewDateRange([item.selection]);
  };

  const selectNoTags = () => {
    setSelectedTags([]);
    getGraph(selectedUsers, selectedClients, selectedProjects, null);
    //detailedReport(selectedUsers, selectedClients, selectedProjects, null);
  };

  const handleClose = () => {
    setShow(false);
    getGraph(selectedUsers, selectedClients, selectedProjects, selectedTags);
    detailedReport(selectedUsers, selectedClients, selectedProjects);
  };

  const slugify = (str) =>
    (str || "project").toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "");

  const projectOnClick = (id, name) => {
    if (id !== 0 && canViewProjectDetail) {
      history(`/project/${id}/${slugify(name)}`);
    }
  };

  const downloadPDF = async () => {
    try {
      let startDate,endDate;
      let dd1 = state[0].startDate.getDate();
      let dd2 = state[0].endDate.getDate();
      let MM1 = state[0].startDate.getMonth();
      let MM2 = state[0].endDate.getMonth();
      let yy1 = state[0].startDate.getFullYear();
      let yy2 =state[0].endDate.getFullYear();

      let start1 = moment({ year :yy1, month :MM1, day :dd1});
      startDate = start1.format(dateFormat);
      let end1 = moment({ year :yy2, month :MM2, day :dd2});
      endDate = end1.format(dateFormat);


      let date = moment().format("YYYY-MM-DD HH:mm:ss");
      if(tab === 2) {
      function buildDetailTableBody(data, columns) {
        var body = [];
        body.push(['Date','Title','Project & Client','Tag' ,'Duration','User']);

        data.forEach(function(row) {
            var dataRow = [];

            columns.forEach(function(column) {
                if(column === 'date') {
                  //console.log(row[column])
                  let date = row[column].substr(0,11);
                  let time = row[column].substr(11,32)
                  //console.log(`${date}\n${time}`,row[column])

                  dataRow.push({text:`${date}\n${time}`});
                }
                else {
                  dataRow.push({text:row[column]});
                }
            })
            body.push(dataRow);
        });

        return body;
    }

      function detailTable(data, columns) {
        return {
          color : "#2E2929",
            table: {
                //widths: [60, 120, 125, 50, 60,125],
                headerRows: 1,
                body: buildDetailTableBody(data, columns)
            },
            layout: 'lightHorizontalLines'
        };
    }

      var dd = {

        pageSize: 'A4',
        pageMargins: [40, 40, 40, 60],
        footer: function(currentPage, pageCount) { return [
          {text:currentPage.toString() + ' of ' + pageCount,alignment:"right",
            color : "#2E2929",margin : [0,0,10,0]}
           ] },

        content: [
          {
            columns : [
              { text : `Detailed Report`, style: 'header', margin : [0,0,0,15], fontSize : 20 ,color : "#2E2929",},
              {
                columns: [
                  { svg: minutezillaPdfLogoSvg, width: 32, margin: [0, 0, 4, 0] },
                  {
                    text: [
                      { text: 'MINUTE', color: '#1a5c30', bold: true, fontSize: 15 },
                      { text: 'ZILLA', color: '#ffffff', bold: true, fontSize: 15 },
                    ],
                    margin: [0, 8, 0, 0],
                  },
                ],
                alignment: 'right',
              },
            ]
          },
          {
            columns : [
              { text : `${startDate} - ${endDate}`, style: 'subheader', margin : [0,0,0,15], fontSize : 12 },
              { text: 'minutezilla.com', link: 'https://minutezilla.com/',alignment : 'right' },
            ]
          },
          { text:workspaceData.title, color : "#2E2929", margin : [0,0,0,10], fontSize : 12},
          { text:`Total ${totalTime.hours} h ${totalTime.minutes} min`,
            color : "#2E2929", margin : [0,0,0,15], fontSize : 12
          },
            detailTable(detailedList, ['date','title','project','tag_title','displayTime','user'])
          ]
      }
      pdfMake.createPdf(dd).download(`detail_reports_${date}.pdf`);
      }
      else if (tab === 1) {
        const captureCanvas = async (selector) => {
          const node = document.getElementById(selector);
          if (!node) return null;
          const canvas = await html2canvas(node);
          return canvas.toDataURL('image/png');
        };

        const imgData1 = await captureCanvas('first');
        const imgData2 = await captureCanvas('second');
        const imgData3 = await captureCanvas('third');

        function buildProjectTableBody(data, columns) {
            var body = [];

            body.push(['Project Title', 'Duration']);

            data.forEach(function(row) {
                var dataRow = [];

                columns.forEach(function(column) {
                    if(column === 'time') {
                      dataRow.push({text:row[column].toString()});
                    }
                    else {
                      dataRow.push({text:row[column].toString(),color : row.projectColor});
                    }
                })

                body.push(dataRow);
            });

            return body;
        }

        function buildTaskTableBody(data, columns) {
            var body = [];

            body.push(['Date','Title','Project Title','Tag' ,'Duration']);

            data.forEach(function(row) {
                var dataRow = [];

                columns.forEach(function(column) {
                  dataRow.push({text:row[column]});
                  /*if(column === 'time') {
                      dataRow.push({text:row[column].toString()});
                    }
                    else {
                      dataRow.push({text:row[column].toString(),color : row.projectColor});
                    }*/
                })

                body.push(dataRow);
            });

            return body;
        }

        function projectTable(data, columns) {
            return {
              margin : [20,40,0,0],
                table: {
                    widths: [225, 75],
                    headerRows: 1,
                    body: buildProjectTableBody(data, columns),
                },
                layout : "headerLineOnly"
            };
        }

        function taskTable(data, columns) {
            return {
              color : "#2E2929",
                table: {
                    widths: [75, 125, 125, 75, 75],
                    headerRows: 1,
                    body: buildTaskTableBody(data, columns)
                },
                layout: 'headerLineOnly'
            };
        }

        var dd = {

          pageSize: 'A4',
          pageMargins: [40, 40, 40, 60],
          footer: function(currentPage, pageCount) { return [
            {text:currentPage.toString() + ' of ' + pageCount,alignment:"right",
              color : "#2E2929",margin : [0,0,10,0]}
             ] },

          content: [
            {
              columns : [
                { text : `Report`, style: 'header', margin : [0,0,0,15], fontSize : 20 ,color : "#2E2929",},
                {
                  columns: [
                    { svg: minutezillaPdfLogoSvg, width: 32, margin: [0, 0, 4, 0] },
                    {
                      text: [
                        { text: 'MINUTE', color: '#1a5c30', bold: true, fontSize: 15 },
                        { text: 'ZILLA', color: '#ffffff', bold: true, fontSize: 15 },
                      ],
                      margin: [0, 8, 0, 0],
                    },
                  ],
                  alignment: 'right',
                },
              ]
            },
            {
              columns : [
                { text : `${startDate} - ${endDate}`, style: 'subheader', margin : [0,0,0,15], fontSize : 10 },
                { text: 'minutezilla.com', link: 'https://minutezilla.com/',alignment : 'right' },
              ]
            },
            {text:workspaceData.title, color : "#2E2929", margin : [0,0,0,5], fontSize : 14},
            imgData1
              ? { image: imgData1, width: 500 }
              : { get text() { return tr("Chart unavailable"); }, margin: [0, 0, 0, 10] },
            imgData2
              ? { image: imgData2, width: 150, margin: [0, 20, 0, 0] }
              : { get text() { return tr("Project breakdown unavailable"); }, margin: [0, 20, 0, 0] },
            { get text() { return tr("PROJECT & TIME"); }, style: 'header',color : "#2E2929", margin : [0,15,0,5], fontSize : 14 },
            {
              columns : [
                imgData3
                  ? { image: imgData3, width: 180, margin: [0,20,0,0] }
                  : { get text() { return tr("Time share unavailable"); }, margin: [0,20,0,0] },
                projectTable(projectArray, ['project_name', 'time']),
              ]
            },
           //

            { get text() { return tr("TASKS, PROJECTS & TIME"); }, style: 'header', color : "#2E2929", margin : [5,20,0,15], fontSize : 14 },
            taskTable(usertimeList, ['date','title','project','tag_title','displayTime'])
            ]
      }

        pdfMake.createPdf(dd).download(`reports_${date}.pdf`);
      }
    } catch (err) {
      console.error("Report download failed", err);
    }


      /*while (heightLeft >= 0) {
        position = heightLeft - imgHeight;
        doc.addPage();
        doc.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pageHeight;
      }*/
  };

  const detailedReport = async (uu, cc, pp, s, le) => {
    try{
        const config = {
            headers: {
              Authorization: `Bearer ${auth.token}`,
              "Content-Type": "application/json",
            },
          };
          let first, last, ss, start, end, ll, arr, i;

          if (s !== null && s !== undefined && le !== null && le !== undefined) {
            first = getDate(s);
            last = getDate(le);
            ss = new Date(s);
            start = new Date(ss.getTime() - ss.getTimezoneOffset() * 60000)
              .toISOString()
              .split("T")[0];
            ll = new Date(le);
            end = new Date(ll.getTime() - ll.getTimezoneOffset() * 60000)
              .toISOString()
              .split("T")[0];
            i = first - last;
          } else {
            first = state[0].startDate.getDate();
            last = state[0].endDate.getDate();
            ss = new Date(state[0].startDate);
            start = new Date(ss.getTime() - ss.getTimezoneOffset() * 60000)
              .toISOString()
              .split("T")[0];
            ll = new Date(state[0].endDate);
            end = new Date(ll.getTime() - ll.getTimezoneOffset() * 60000)
              .toISOString()
              .split("T")[0];
            i = first - last;
          }
          let clients = cc !== null && cc !== undefined ? cc : "";
          let projects = pp !== null && pp !== undefined ? pp : "";
          let users = uu !== null && uu !== undefined ? uu : [user_id];
          let workspace_id = auth.workspace_id;
          let is_workspace_admin = auth.is_workspace_admin;
          const body = JSON.stringify({
              workspace_id,
              start,
              end ,
              is_workspace_admin,
              clients,
              projects,
              users,
              is_viewer
          });

        let res = await axios.post("/api/report/detailed", body, config);
        if(res.status === 200) {
          let roundingData1 = await currentWorkspaceData() || {};
          let rounding_duration,rounding_to;
          if(roundingData1.is_time_rounding === 1) {
            let arr1 = roundingData1.rounding_duration.split(' ');
            let arr2 = roundingData1.rounding_to.split(' ');
            if(arr1[1].charAt(0) === 'm') {
              rounding_duration = parseInt(arr1[0]);
            }
            else if(arr1[1].charAt(0) === 'h') {
              rounding_duration = parseInt(arr1[0])*60;
            }
            rounding_to = arr2[1];
          }
          let roundingData = {
            is_time_rounding : roundingData1.is_time_rounding,
            rounding_duration,
            rounding_to
          }
          if (res.data.totalTime.length > 0) {
            let totalTime = 0;
            let totalTime2 = "00:00:00";
            res.data.totalTime.map(item => {
              if(moment(item.timer_start,'X').isBetween(start,end,'days',[])) {
                //totalTime = totalTime + parseInt(item.timerTime);
                if(roundingData.is_time_rounding === 1) {
                  let t = millisecondsToTime(parseInt(item.timerTime));
                  let t1 =  roundingFunction(t,roundingData.rounding_duration,roundingData.rounding_to);
                  totalTime2 = sumOfTImeDuration(t1,totalTime2);//moment.duration(totalTime2).add(t1);
                } else {
                  totalTime = totalTime + parseInt(item.timerTime);
                }
              }
            })
            if(roundingData.is_time_rounding === 1) {
              let arr = totalTime2.split(':');
              let hours = arr[0];
              let minutes = arr[1];
              let seconds = arr[2];
              setTotalTime({ hours: hours, minutes: minutes, seconds: seconds });
            }
            else{
                // 1- Convert to seconds:
                let seconds = (totalTime / 1000).toFixed();
                // 2- Extract hours:
                let hours = parseInt( seconds / 3600); // 3,600 seconds in 1 hour
                if(parseInt(hours/10) === 0) {
                  hours = ("0" + hours);
                }
                seconds = seconds % 3600; // seconds remaining after extracting hours
                // 3- Extract minutes:
                let minutes = ("0" +parseInt( seconds / 60 )).slice(-2); // 60 seconds in 1 minute
                // 4- Keep only seconds not extracted to minutes:
                seconds = ("0" + (seconds % 60)).slice(-2);
            setTotalTime({ hours: hours, minutes: minutes, seconds: seconds });
            }
          }
          else {
            setTotalTime({ hours: "00", minutes: "00", seconds: "00" });
          }

          let taskList = [];
          let time_duration_format = "Improved";
          let date_format = "DD-MM-YYYY";
          let time_format = "12-hour";
          if(auth.user_properties !== null &&
            auth.user_properties !== undefined) {
              time_duration_format = auth.user_properties.timeDurationFormat.split(' ')[0];
              date_format = auth.user_properties.dateFormat;
              time_format = auth.user_properties.timeFormat;
          }
          res.data.results.map((item,index) => {
            if(moment(item.timer_start,'X').isBetween(start,end,'days',[])) {
              let time;
              if(roundingData.is_time_rounding === 1) {
                let t1 = item.displayTime ? roundingFunction(item.displayTime,roundingData.rounding_duration,roundingData.rounding_to) : item.displayTime;
                time = alterDisplayTime(t1, time_duration_format);
              }
              else {
                time = alterDisplayTime(item.displayTime, time_duration_format);
              }
              taskList.push({
                date: `${moment.unix(item.timer_start)
                  .format(date_format)} ${moment.unix(item.timer_start)
                  .format(alterTimeFormat(time_format))} - ${moment.unix(item.timer_end)
                  .format(alterTimeFormat(time_format))}`,
                time : item.displayTime,
                displayTime: time,
                //alterDisplayTime(item.displayTime, auth.user_properties.timeDurationFormat.split(' ')[0]),
                title: item.title !== null && item.title !== undefined && item.title !== ""?
                        capitalizeFirstLetter(item.title):"(No description)",
                project: item.project !== null && item.project !== undefined && item.project !== ""
                ? item.client!== null && item.client!== undefined && item.client !== ""
                ? `${capitalizeFirstLetter(item.project)} - ${capitalizeFirstLetter(item.client)}`
                : capitalizeFirstLetter(item.project)
                : "(No project)",
                project_color : item.project_color,
                project_name : item.project,
                client: item.client,
                workspace_id: item.workspace_id,
                tag_title: item.tag_title !== null && item.tag_title !== undefined && item.tag_title !== ""?
                capitalizeFirstLetter(item.tag_title):"(No tag)",
                user : item.first_name + " " + item.last_name,
                tagcolor : item.tagcolor,
                timerStart: item.timerStart,
                timerTime: item.timerTime,
                isStop: item.isStop,
                is_billable:item.is_billable,
                timer_start : item.timer_start,
                timer_end : item.timer_end
              })
            }
          })
          setList(taskList)
        }
    }
    catch(err) {
        console.log(err);
        if (err.response) {
          console.log(err.response);
        }
    }
}

  const data = {
    labels: dates,
    datasets: [
      {
        label: "",
        fill: false,
        lineTension: 0.1,
        backgroundColor: "#2d7a47",
        hoverBackgroundColor: "#23c65a",
        hoverBorderColor: "#ffffff",
        hoverBorderWidth: 2,
        borderColor: "#EEF1EE",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(75,192,192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(75,192,192,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: times,
      },
    ],
  };

  const dataProject = {
    labels: projectName,
    datasets: [
      {
        get label() { return tr("Hours"); },
        fill: false,
        lineTension: 0.1,
        backgroundColor: projectColor, //'rgba(75,192,192,0.4)',
        borderColor: "#EEF1EE",
        borderCapStyle: "butt",
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: "miter",
        pointBorderColor: "rgba(75,192,192,1)",
        pointBackgroundColor: "#fff",
        pointBorderWidth: 1,
        pointHoverRadius: 5,
        pointHoverBackgroundColor: "rgba(75,192,192,1)",
        pointHoverBorderColor: "rgba(220,220,220,1)",
        pointHoverBorderWidth: 2,
        pointRadius: 1,
        pointHitRadius: 10,
        data: projectTime,
      },
    ],
  };

  const dataPolar = {
    labels: projectName,
    datasets: [
      {
        data: projectTime,
        backgroundColor: projectColor.map(c => `${c}cc`),
        borderColor: projectColor.map(c => c),
        borderWidth: 1.5,
      },
    ],
  };

  const timeShareData = useMemo(() => {
    const total = projectTime.reduce((s, t) => s + parseFloat(t || 0), 0);
    return projectArray
      .map((p, i) => ({
        name: p.project_name,
        color: p.projectColor || '#a0aec0',
        time: p.time,
        hours: parseFloat(projectTime[i] || 0),
        pct: total > 0 ? (parseFloat(projectTime[i] || 0) / total) * 100 : 0,
      }))
      .sort((a, b) => b.hours - a.hours);
  }, [projectArray, projectTime]);

  const overviewDisplayData = overviewData || overviewFallbackData;

  return (
    <div>
      <SideBar />

      {/* Slim top nav bar */}
      <div className='header rp-header'>
        <div className='container-fluid'>
          <div className='rp-top-nav'>
            <span className='rp-nav-title'>{tr("Reports")}</span>
            <nav className='rp-tab-group'>
              <a className={tab===1?'rp-tab rp-tab--active':'rp-tab'} onClick={()=>setTab(1)}>{tr("Summary")}</a>
              <a className={tab===2?'rp-tab rp-tab--active':'rp-tab'} onClick={()=>setTab(2)}>{tr("Detailed")}</a>
            </nav>
            <div className='rp-nav-actions'>
              <div className={downloadDDOpen?'rp-export-btn dropdown show':'rp-export-btn dropdown'}>
                <button className='btn-dash-secondary dropdown-toggle' type='button'
                  data-toggle='dropdown' aria-haspopup='true' aria-expanded='false'
                  onClick={()=>setDownloadDDOpen(true)}>
                  <svg
                    xmlns='http://www.w3.org/2000/svg'
                    width='16'
                    height='16'
                    viewBox='0 0 20 20'
                  >
                    <path
                      fill='currentColor'
                      fill-rule='evenodd'
                      d='M11 9h2.002c.55 0 .734.36.407.812l-2.819 3.876c-.326.449-.853.451-1.18 0L6.59 9.812C6.262 9.363 6.451 9 6.995 9H9V3a1 1 0 1 1 2 0v6zm-8 9a1 1 0 0 1 0-2h14a1 1 0 0 1 0 2H3z'
                    ></path>
                  </svg>{tr("Export")} </button>
                <div className={downloadDDOpen?'dropdown-menu show':'dropdown-menu'}
                  style={{position:'absolute',right:'0',left:'auto',top:'100%'}}>
                  <button className='dropdown-item' type='button' onClick={()=>downloadPDF()}>{tr("Download PDF")}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className='content-wrap dashboard-bg' id='wrapper'>
        <div className='main'>

          {/* Page header */}
          <div className='dash-page-header'>
            <div className='dash-page-title'>
              <h1>{tr("Reports")}</h1>
              <p>{tr("Analyze time tracked across projects and team members")}</p>
            </div>
          </div>

          {/* Period tabs */}
          <div className='rp-period-bar'>
            {[
              { key: 'week',   get label() { return tr("This Week"); } },
              { key: '7days',  get label() { return tr("Last 7 Days"); } },
              { key: 'month',  get label() { return tr("This Month"); } },
              { key: '30days', get label() { return tr("Last 30 Days"); } },
              { key: 'year',   get label() { return tr("This Year"); } },
              { key: 'custom', get label() { return tr("Custom"); } },
            ].map(p => (
              <button
                key={p.key}
                className={activePeriod === p.key ? 'rp-period-btn rp-period-btn--active' : 'rp-period-btn'}
                onClick={() => setPeriodRange(p.key)}
              >
                {p.label}
                {p.key === 'custom' && activePeriod === 'custom' && (
                  <span className='rp-custom-range'>
                    {' '}({state[0].startDate.toLocaleDateString(getLocale())} – {state[0].endDate.toLocaleDateString(getLocale())})
                  </span>
                )}
              </button>
            ))}
          </div>

          {/* Filter bar */}
          <div className='rp-filter-bar'>
            <span className='rp-filter-label'>{tr("Filter by:")}</span>

            {/* Client dropdown */}
            <div
              onClick={() => openClientDD(true)}
              className={clientDD ? "report-filter-item-box dropdown show" : "report-filter-item-box dropdown"}
            >
              <div
                className={selectedClients.length > 0 ? "rp-filter-pill dropdown-toggle rp-filter-pill--active" : "rp-filter-pill dropdown-toggle"}
                data-toggle='dropdown'
                aria-expanded='false'
              >
                <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 18 18'>
                  <g>
                    <rect width='18' height='18' rx='4'></rect>
                    <path d='M7.5 9.5C7.5 11 4 10.5 4 13.5 4 14.5 4 13.5 4 13.5 4 14.3 4.7 15 5.5 15L12.5 15C13.3 15 14 14.3 14 13.5 14 13.5 14 14.5 14 13.5 14 10.5 10.5 11 10.5 9.5 10.5 8.5 12 8 12 6 12 4.5 10.7 3 9 3 7.3 3 6 4.5 6 6 6 8 7.5 8.5 7.5 9.5Z'></path>
                  </g>
                </svg>
                <span>{tr("Client")}{selectedClients.length > 0 ? ` (${selectedClients.length})` : ''}</span>
              </div>
              <div
                className={clientDD ? "dropdown-menu filter-by-button-dropdown-wrap show" : "dropdown-menu filter-by-button-dropdown-wrap"}
                x-placement='bottom-start'
                style={{ position: "absolute", transform: "translate3d(6px, 27px, 0px)", top: "0px", left: "0px", willChange: "transform" }}
              >
                <div className='Teamdropdown_container'>
                  <div className='filter-search-field-wrap'>
                    <div className='team-search-contain'>
                      <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'>
                        <path fill='#cecece' d='M13.9,12.8L10.2,9c0.7-0.9,1.2-2.2,1.2-3.4C11.3,2.5,8.8,0,5.7,0C2.6,0,0,2.6,0,5.7c0,3.2,2.5,5.7,5.7,5.7 c1.2,0,2.3-0.4,3.4-1.2l3.6,3.6C12.8,14,12.9,14,13,14s0.1,0,0.2-0.1l0.8-0.8C14,13.1,14,12.9,13.9,12.8z M9.8,5.7 c0,2.2-1.8,4-4.1,4s-4.1-1.8-4.1-4c0-2.2,1.9-4.1,4.1-4.1C8,1.7,9.8,3.5,9.8,5.7z'></path>
                      </svg>
                      <input type='text' placeholder={tr("Find Client...")} className='team-search-field' value={clientTerm} onChange={handleClientTerm} onKeyUp={() => getClientList()} />
                    </div>
                  </div>
                  <div className='team-list-contain-wrap'>
                    <div className='team-list-inner-box'>
                      <div className='virtualized__List' style={{ position: "relative", overflow: "hidden" }}>
                        <div className='filter-by-check-wrap' onClick={() => handleClientCheck(0)}>
                          <div className='custom-checkbox-wrap'>
                            <label>
                              <span className={selectedClients.includes(0) ? "custom-checkboxes selected" : "custom-checkboxes"}>
                                <input type='checkbox' name='filter-item[]' />
                              </span>
                            </label>
                          </div>
                          <div className='team-name-filter-by'>
                            <div title='webteam'>{tr("Projects Without Clients")}</div>
                          </div>
                        </div>
                        <div className='inner-scrollar-container' style={{ overflow: "hidden", position: "relative" }}>
                          <div style={{ width: "100%" }}>
                            <div className='top-lebel-wrap'>
                              <span className='label-text'>{tr("Client")}</span>
                              <div>
                                <a tabindex='-1'><span onClick={() => selectAllClients()}>{tr("All")}</span></a>
                                <a tabindex='-1'><span onClick={() => { selectNoClients(); }}>{tr("None")}</span></a>
                              </div>
                            </div>
                          </div>
                          {clientList.map((item, index) => (
                            <div style={{ width: "100%" }} key={index}>
                              <div className='filter-by-check-wrap' onClick={() => handleClientCheck(item.id)}>
                                <div className='custom-checkbox-wrap'>
                                  <label>
                                    <span className={selectedClients.includes(item.id) ? "custom-checkboxes selected" : "custom-checkboxes"}>
                                      <input type='checkbox' name='filter-item[]' />
                                    </span>
                                  </label>
                                </div>
                                <div className='team-name-filter-by'>
                                  <div title='webteam'>{item.display_name || item.company_name || item.client_name}</div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Project dropdown */}
            <div
              onClick={() => openProjectDD(true)}
              className={projectDD ? "report-filter-item-box dropdown show" : "report-filter-item-box dropdown"}
            >
              <div
                className={selectedProjects.length > 0 ? "rp-filter-pill dropdown-toggle rp-filter-pill--active" : "rp-filter-pill dropdown-toggle"}
                data-toggle='dropdown'
                aria-expanded={projectDD ? "true" : "false"}
              >
                <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 18 18'>
                  <g fill='none' fill-rule='evenodd'>
                    <rect width='18' height='18' fill='#cecece' rx='4'></rect>
                    <g fill='#fafbfc'>
                      <path d='M3 9h12v4.002A2.005 2.005 0 0 1 12.991 15H5.01A2.006 2.006 0 0 1 3 13.002V9zM3 5.005C3 3.898 3.898 3 4.998 3h2.004C8.106 3 9 3.894 9 5.005V8H3V5.005z'></path>
                      <path d='M3 6.5C3 5.672 3.68 5 4.496 5h9.008C14.33 5 15 5.666 15 6.5V8H3V6.5z'></path>
                    </g>
                  </g>
                </svg>
                <span>{tr("Project")}{selectedProjects.length > 0 ? ` (${selectedProjects.length})` : ''}</span>
              </div>
              <div
                className={projectDD ? "dropdown-menu filter-by-button-dropdown-wrap show" : "dropdown-menu filter-by-button-dropdown-wrap"}
                x-placement='bottom-start'
                style={{ position: "absolute", transform: "translate3d(6px, 27px, 0px)", top: "0px", left: "0px", willChange: "transform" }}
              >
                <div className='Teamdropdown_container'>
                  <div className='filter-search-field-wrap'>
                    <div className='team-search-contain'>
                      <svg xmlns='http://www.w3.org/2000/svg' width='14' height='14' viewBox='0 0 14 14'>
                        <path fill='#cecece' d='M13.9,12.8L10.2,9c0.7-0.9,1.2-2.2,1.2-3.4C11.3,2.5,8.8,0,5.7,0C2.6,0,0,2.6,0,5.7c0,3.2,2.5,5.7,5.7,5.7 c1.2,0,2.3-0.4,3.4-1.2l3.6,3.6C12.8,14,12.9,14,13,14s0.1,0,0.2-0.1l0.8-0.8C14,13.1,14,12.9,13.9,12.8z M9.8,5.7 c0,2.2-1.8,4-4.1,4s-4.1-1.8-4.1-4c0-2.2,1.9-4.1,4.1-4.1C8,1.7,9.8,3.5,9.8,5.7z'></path>
                      </svg>
                      <input type='text' tabindex='4' placeholder={tr("Find Project...")} className='team-search-field' value={projectTerm} onChange={handleProjectTerm} onKeyUp={() => getProjectList()} />
                    </div>
                  </div>
                  <div className='team-list-contain-wrap'>
                    <div className='team-list-inner-box'>
                      <div className='virtualized__List' style={{ position: "relative", overflow: "hidden" }}>
                        <div className='filter-by-check-wrap' onClick={() => handleProjectCheck(0)}>
                          <div className='custom-checkbox-wrap'>
                            <label>
                              <span className={selectedProjects.includes(0) ? "custom-checkboxes selected" : "custom-checkboxes"}>
                                <input type='checkbox' name='filter-item[]' />
                              </span>
                            </label>
                          </div>
                          <div className='team-name-filter-by'>
                            <div title='webteam'>{tr("Entries Without Project")}</div>
                          </div>
                        </div>
                        <div className='inner-scrollar-container' role='rowgroup' style={{ overflow: "hidden", position: "relative" }}>
                          <div style={{ width: "100%" }}>
                            <div className='top-lebel-wrap'>
                              <span className='label-text'>{tr("Project")}</span>
                              <div>
                                <a tabindex='-1'><span onClick={() => selectAllProjects()}>{tr("All")}</span></a>
                                <a tabindex='-1'><span onClick={() => selectNoProjects()}>{tr("None")}</span></a>
                              </div>
                            </div>
                          </div>
                          {projectList.map((item, index) => (
                            <div style={{ width: "100%" }} key={index}>
                              <div className='filter-by-check-wrap' onClick={() => { handleProjectCheck(item.id); }}>
                                <div className='custom-checkbox-wrap'>
                                  <label>
                                    <span className={selectedProjects.includes(item.id) ? "custom-checkboxes selected" : "custom-checkboxes"}>
                                      <input type='checkbox' name='filter-item[]' />
                                    </span>
                                  </label>
                                </div>
                                <div className='team-name-filter-by'>
                                  <div title='webteam'>{item.project_name}</div>
                                </div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Users dropdown */}
            <div
              className={userDD ? "report-filter-item-box dropdown show" : "report-filter-item-box dropdown"}
              onClick={() => openUserDD(true)}
              style={{display: is_viewer ? "" : "none"}}
            >
              <div
                className={selectedUsers.length > 0 ? "rp-filter-pill dropdown-toggle rp-filter-pill--active" : "rp-filter-pill dropdown-toggle"}
                id="teammenudrop" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 18 18">
                  <g fill="none">
                    <rect width="18" height="18" rx="4" fill="#cecece"></rect>
                    <path d="M11.1 10.2C11.5 11.2 11.9 11.9 11.9 13 11.9 14.6 11 15 11 15L13.5 15C14.3 15 15 14.3 15 13.5 15 13.5 15 13.8 15 13.1 15 11.1 13 10.8 13 10.1 13 8.9 14.2 9.2 14.2 7.3 14.2 6.1 13.4 4.9 12 4.9 10.5 4.9 9.8 6.1 9.8 7.3 9.8 8.9 10.6 9.2 11.1 10.2ZM5.3 8.8C5.3 10.7 3 10 3 13.1 3 13.8 3 13.1 3 13.1 3 14.1 3.9 15 5 15L8.5 15C9.6 15 10.5 14.1 10.5 13.1 10.5 13.1 10.5 13.8 10.5 13.1 10.5 10 8.2 10.7 8.2 8.8 8.2 8 9.3 8 9.3 5.7 9.3 4.5 8.6 3 6.8 3 4.9 3 4.2 4.5 4.2 5.7 4.2 8 5.3 8 5.3 8.8Z" fill="#ffffff"></path>
                  </g>
                </svg>
                <span>{tr("Users")}{selectedUsers.length > 0 ? ` (${selectedUsers.length})` : ''}</span>
              </div>
              <div
                className={userDD ? "dropdown-menu filter-by-button-dropdown-wrap show" : "dropdown-menu filter-by-button-dropdown-wrap"}
                x-placement="bottom-start"
                style={{position: "absolute", transform: "translate3d(6px, 27px, 0px)", top: "0px", left: "0px", willChange: "transform"}}
              >
                <div className="Teamdropdown_container">
                  <div className="filter-search-field-wrap">
                    <div className="team-search-contain">
                      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14">
                        <path fill="#cecece" d="M13.9,12.8L10.2,9c0.7-0.9,1.2-2.2,1.2-3.4C11.3,2.5,8.8,0,5.7,0C2.6,0,0,2.6,0,5.7c0,3.2,2.5,5.7,5.7,5.7 c1.2,0,2.3-0.4,3.4-1.2l3.6,3.6C12.8,14,12.9,14,13,14s0.1,0,0.2-0.1l0.8-0.8C14,13.1,14,12.9,13.9,12.8z M9.8,5.7 c0,2.2-1.8,4-4.1,4s-4.1-1.8-4.1-4c0-2.2,1.9-4.1,4.1-4.1C8,1.7,9.8,3.5,9.8,5.7z"></path>
                      </svg>
                      <input type="text" tabindex="4" placeholder={tr("Find users...")} className="team-search-field" value=""/>
                    </div>
                  </div>
                  <div className="team-list-contain-wrap">
                    <div className="team-list-inner-box">
                      <div className="virtualized__List" style={{position: "relative", overflow: "hidden"}}>
                        <div className="inner-scrollar-container" style={{overflow: "hidden", position: "relative"}}></div>
                        <div className="inner-scrollar-container" role="rowgroup" style={{overflow:"hidden",position:"relative"}}>
                          <div className="top-lebel-wrap">
                            <span className="label-text">{tr("Members")}</span>
                            <div>
                              <a tabindex="-1"><span onClick={()=>selectAllUsers()}>{tr("All")}</span></a>
                            </div>
                          </div>
                          {teamList.map((item,index) => (
                            <div className="filter-by-check-wrap" key={index} onClick={()=>handleUserCheck(item.user_id)}>
                              <div className="custom-checkbox-wrap">
                                <label>
                                  <span className={selectedUsers.includes(item.user_id) ? "custom-checkboxes selected" : "custom-checkboxes"}>
                                    <input type="checkbox" name="filter-item[]"/>
                                  </span>
                                </label>
                              </div>
                              <div className="team-name-filter-by">
                                <div>{item.name}</div>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Tags dropdown */}
            <div
              className={tagDD ? "report-filter-item-box dropdown show" : "report-filter-item-box dropdown"}
              onClick={() => openTagDD(true)}
            >
              <div
                className={selectedTags.length > 0 ? "rp-filter-pill dropdown-toggle rp-filter-pill--active" : "rp-filter-pill dropdown-toggle"}
                data-toggle="dropdown" aria-haspopup="true" aria-expanded={tagDD ? "true" : "false"}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 17 17">
                  <path d="M0 6.002c0 1.103.633 2.63 1.416 3.414l6.168 6.168a1.996 1.996 0 0 0 2.828.004l5.176-5.176c.78-.78.78-2.045-.004-2.828L9.416 1.416C8.634.634 7.113 0 6.002 0H1.998A1.993 1.993 0 0 0 0 1.998v4.004zM4 6a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" fill="currentColor" fillRule="evenodd"/>
                </svg>
                <span>Tags{selectedTags.length > 0 ? ` (${selectedTags.length})` : ''}</span>
              </div>
              <div
                className={tagDD ? "dropdown-menu filter-by-button-dropdown-wrap show" : "dropdown-menu filter-by-button-dropdown-wrap"}
                style={{ position: "absolute", transform: "translate3d(6px, 27px, 0px)", top: "0px", left: "0px", willChange: "transform" }}
              >
                <div className="Teamdropdown_container">
                  <div className="team-list-contain-wrap">
                    <div className="team-list-inner-box">
                      <div className="virtualized__List" style={{ position: "relative", overflow: "hidden" }}>
                        <div className="inner-scrollar-container" role="rowgroup" style={{ overflow: "hidden", position: "relative" }}>
                          <div className="top-lebel-wrap">
                            <span className="label-text">Tags</span>
                            <div>
                              <a tabIndex="-1"><span onClick={() => selectAllTags()}>{tr("All")}</span></a>
                              <a tabIndex="-1"><span onClick={() => selectNoTags()}>{tr("None")}</span></a>
                            </div>
                          </div>
                          {tagList.map((item, index) => (
                            <div className="filter-by-check-wrap" key={index} onClick={() => handleTagCheck(item.id)}>
                              <div className="custom-checkbox-wrap">
                                <label>
                                  <span className={selectedTags.includes(item.id) ? "custom-checkboxes selected" : "custom-checkboxes"}>
                                    <input type="checkbox" name="filter-item[]" />
                                  </span>
                                </label>
                              </div>
                              <div className="team-name-filter-by" style={{ color: item.tagcolor }}>
                                {item.tag_title}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>

          {/* Modal date picker */}
          <Modal
            show={show}
            onHide={handleClose}
            size='lg'
            backdrop='static'
          >
            <Modal.Header closeButton>
              <span className="rp-date-modal-title">{tr("Select date range")}</span>
            </Modal.Header>
            <Modal.Body>
              <div className="rp-date-modal-body">
                <DateRangePicker
                  onChange={handleSelect}
                  ranges={state}
                  weekStartsOn={firstDayOfWeek}
                  monthsShown={2}
                />
              </div>
            </Modal.Body>
          </Modal>

          {/* TAB 1: SUMMARY */}
          {tab === 1 ? (
            <>
              {/* Stats row */}
              <div className='rp-stats-row'>
                <div className='dash-stat-card dash-stat-card--dark rp-stat-primary'>
                  <p className='dash-stat-label'>{tr("Tracked Hours")}</p>
                  <h2 className='dash-stat-value rp-hms'>
                    <span className='rp-th'>{clockedTime.hours}</span>
                    <span className='rp-tsep'>:</span>
                    <span className='rp-tm'>{clockedTime.minutes}</span>
                    <span className='rp-ts'>:{clockedTime.seconds}</span>
                  </h2>
                  <p className='dash-stat-trend dash-stat-trend--neutral'>{tr("Total for selected period")}</p>
                </div>
                <div className='dash-stat-card rp-stat-light'>
                  <p className='dash-stat-label'>{tr("Projects")}</p>
                  <h2 className='dash-stat-value'>{projectArray.length}</h2>
                  <p className='dash-stat-trend dash-stat-trend--neutral'>{tr("Active in period")}</p>
                </div>
                {is_viewer && (
                  <div className='dash-stat-card rp-stat-light'>
                    <p className='dash-stat-label'>{tr("Team Members")}</p>
                    <h2 className='dash-stat-value'>{teamList.length}</h2>
                    <p className='dash-stat-trend dash-stat-trend--neutral'>{tr("In workspace")}</p>
                  </div>
                )}
              </div>

              {/* Full-width bar chart */}
              <div className='dash-card rp-chart-card'>
                <div className='dash-card-header'>
                  <div>
                    <p className='dash-card-title'>{tr("Time Distribution")}</p>
                    <p className='dash-card-subtitle'>{tr("Hours tracked per day in selected range")}</p>
                  </div>
                </div>
                <div className='rp-chart-wrap' id='first'>
                  <Bar key={getLocale()}
                    data={data}
                    options={{
                      maintainAspectRatio: false,
                      animation: { duration: 400 },
                      plugins: {
                        legend: { display: false },
                        title: { display: true, get text() { return tr("Time in Hours"); } },
                        tooltip: { enabled: false, external: customTooltip },
                      },
                      scales: {
                        x: { grid: { drawOnChartArea: false, color: '#aaa', borderDash: [1, 3] } },
                        y: { beginAtZero: true },
                      },
                    }}
                  />
                </div>
              </div>

              {/* Bottom grid: doughnut + breakdown */}
              <div className='rp-bottom-grid'>
                {/* By Project doughnut */}
                <div className='dash-card rp-doughnut-card'>
                  <div className='dash-card-header rp-polar-header'>
                    <p className='dash-card-title'>{tr("By Project")}</p>
                    {projectName.length > 0 && (
                      <div className='rp-polar-legend'>
                        {projectName.map((name, i) => (
                          <span className='rp-polar-legend-item' key={i}>
                            <span className='rp-polar-legend-dot' style={{ background: projectColor[i] || '#a0aec0' }} />
                            {name}
                          </span>
                        ))}
                      </div>
                    )}
                  </div>
                  <div className='dash-card-body rp-doughnut-body' id='second'>
                    {projectTime.length > 0 ? (
                      <Doughnut key={getLocale()}
                        ref={chart}
                        data={dataProject}
                        width={385}
                        height={385}
                        options={{
                          responsive: false,
                          maintainAspectRatio: false,
                          legend: { display: false },
                          title: { display: false },
                          hover: { animationDuration: 400 },
                          onHover: spotlightHover,
                          tooltips: { enabled: false, custom: customTooltip },
                        }}
                      />
                    ) : (
                      <div className='dash-empty-state'>
                        <svg width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5'><circle cx='12' cy='12' r='10'/><path d='M12 8v4m0 4h.01'/></svg>{tr("No project data")} </div>
                    )}
                  </div>
                </div>

                {/* Time Share — horizontal bar chart */}
                <div className='dash-card rp-polar-card rp-time-share-card'>
                  <div className='dash-card-header rp-time-share-header'>
                    <div>
                      <p className='dash-card-title'>{tr("Time Share")}</p>
                      <p className='dash-card-subtitle'>{tr("Share of tracked time per project")}</p>
                    </div>
                  </div>
                  <div className='dash-card-body rp-time-share-body' id='third'>
                    {timeShareData.length > 0 ? (
                      <div className='rp-timeshare-bars'>
                        {timeShareData.map((item, i) => (
                          <div className='rp-timeshare-row' key={i}>
                            <div className='rp-timeshare-label-wrap'>
                              <span className='rp-timeshare-dot' style={{ background: item.color }} />
                              <span className='rp-timeshare-name' title={item.name}>{item.name}</span>
                            </div>
                            <div className='rp-timeshare-track'>
                              <div
                                className='rp-timeshare-fill'
                                style={{ width: `${item.pct}%`, background: item.color }}
                              />
                            </div>
                            <div className='rp-timeshare-meta'>
                              <span className='rp-timeshare-pct'>{item.pct.toFixed(1)}%</span>
                              <span className='rp-timeshare-time'>{item.time}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <div className='dash-empty-state'>
                        <svg width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5'><circle cx='12' cy='12' r='10'/><path d='M12 8v4m0 4h.01'/></svg>{tr("No project data")} </div>
                    )}
                  </div>
                </div>

                {isOverviewPrivileged && (
                  <div className='dash-card rp-overview-card rp-overview-card--inline'>
                    <div className='dash-card-header rp-overview-header'>
                      <div className='rp-overview-copy'>
                        <p className='dash-card-title'>{tr("Workspace Overview")}</p>
                        <p className='dash-card-subtitle'>{tr("Pick a month or date range to review tracked work. Billable means time entries marked billable.")}</p>
                      </div>
                      <div className='rp-overview-actions' ref={overviewDateMenuRef}>
                        <button
                          type='button'
                          className='rp-overview-filter rp-overview-filter--selected'
                          onClick={() => setOverviewDateMenuOpen((value) => !value)}
                        >
                          <span>{overviewRangeLabel}</span>
                          <span className='rp-overview-filter-caret' />
                        </button>

                        {overviewDateMenuOpen && (
                          <div className='rp-overview-date-menu'>
                            <div className='rp-overview-date-menu-tabs'>
                              <button
                                type='button'
                                className={overviewRangeMode === 'month' ? 'rp-overview-pill rp-overview-pill--active' : 'rp-overview-pill'}
                                onClick={() => setOverviewRangeMode('month')}
                              >{tr("Month")} </button>
                              <button
                                type='button'
                                className={overviewRangeMode === 'range' ? 'rp-overview-pill rp-overview-pill--active' : 'rp-overview-pill'}
                                onClick={() => setOverviewRangeMode('range')}
                              >{tr("Date Range")} </button>
                            </div>

                            {overviewRangeMode === 'month' ? (
                              <div className='rp-overview-date-menu-body'>
                                <DatePicker locale={getLocale() === "de-DE" ? deDateLocale : enDateLocale}
                                  inline
                                  selected={overviewMonthDate}
                                  onChange={(date) => {
                                    if (date instanceof Date && !Number.isNaN(date.getTime())) {
                                      setOverviewMonthDate(startOfMonth(date));
                                      setOverviewDateMenuOpen(false);
                                    }
                                  }}
                                  showMonthYearPicker
                                  maxDate={new Date()}
                                  calendarStartDay={auth.user_properties !== null && auth.user_properties !== undefined ? auth.user_properties.firstDayOfWeek : firstDayOfWeek}
                                />
                              </div>
                            ) : (
                              <div className='rp-overview-date-menu-body rp-overview-date-menu-body--range'>
                                <DateRangePicker
                                  onChange={setOverviewDateRange}
                                  ranges={overviewDateRange}
                                  weekStartsOn={auth.user_properties !== null && auth.user_properties !== undefined ? auth.user_properties.firstDayOfWeek : firstDayOfWeek}
                                  maxDate={new Date()}
                                />
                              </div>
                            )}
                          </div>
                        )}
                      </div>
                    </div>

                    <div className='dash-card-body rp-overview-body'>
                      {overviewLoading && !overviewData && !overviewFallbackData ? (
                        <div className='rp-overview-skeleton'>
                          <div className='rp-overview-skeleton-grid'>
                            <div className='rp-overview-skeleton-card' />
                            <div className='rp-overview-skeleton-card' />
                            <div className='rp-overview-skeleton-card' />
                            <div className='rp-overview-skeleton-card' />
                          </div>
                          <div className='rp-overview-skeleton-bar' />
                        </div>
                      ) : (overviewData || overviewFallbackData) ? (
                        <>
                          <div className='rp-overview-chart-wrap'>
                            <Bar key={getLocale()} data={overviewChartData} options={overviewChartOptions} />
                          </div>

                          <div className='rp-overview-quickstats'>
                            <div className='rp-overview-metric'>
                              <span className='rp-overview-metric-label'>{tr("Employees")}</span>
                              <strong className='rp-overview-metric-value'>
                                {overviewData
                                  ? overviewData.employees
                                  : teamList.length > 0
                                    ? teamList.length
                                    : (overviewFallbackData?.employees || '—')}
                              </strong>
                            </div>
                            <div className='rp-overview-metric rp-overview-metric--accent'>
                              <span className='rp-overview-metric-label'>{tr("Billable Hours")}</span>
                              <strong className='rp-overview-metric-value'>{formatOverviewDuration((overviewData || overviewFallbackData).billable_ms)}</strong>
                            </div>
                            <div className='rp-overview-metric'>
                              <span className='rp-overview-metric-label'>{tr("Tracked Hours")}</span>
                              <strong className='rp-overview-metric-value'>{formatOverviewDuration((overviewData || overviewFallbackData).tracked_ms)}</strong>
                            </div>
                            <div className='rp-overview-metric'>
                              <span className='rp-overview-metric-label'>{tr("Billable %")}</span>
                              <strong className='rp-overview-metric-value'>{Number((overviewData || overviewFallbackData).billable_percent || 0).toFixed(1)}%</strong>
                            </div>
                          </div>
                          <div className='rp-overview-progress'>
                            <div className='rp-overview-progress-head'>
                              <span>{tr("Billable share")}</span>
                              <strong>{Number((overviewData || overviewFallbackData).billable_percent || 0).toFixed(1)}%</strong>
                            </div>
                            <div className='rp-overview-progress-track'>
                              <div
                                className='rp-overview-progress-fill'
                                style={{ width: `${Math.max(0, Math.min(100, Number((overviewData || overviewFallbackData).billable_percent || 0)))}%` }}
                              />
                            </div>
                          </div>
                          {overviewData == null && overviewFallbackData != null && (
                            <div className='rp-overview-fallback-note'>{tr("Showing current report data until the workspace summary loads.")} </div>
                          )}
                        </>
                      ) : overviewError ? (
                        <div className='dash-empty-state rp-overview-empty'>
                          <svg width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5'>
                            <circle cx='12' cy='12' r='10' />
                            <path d='M12 8v4m0 4h.01' />
                          </svg>
                          {overviewError}
                        </div>
                      ) : (
                        <div className='dash-empty-state rp-overview-empty'>
                          <svg width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5'>
                            <circle cx='12' cy='12' r='10' />
                            <path d='M12 8v4m0 4h.01' />
                          </svg>{tr("No overview data available")} </div>
                      )}
                    </div>
                  </div>
                )}

                {isOverviewPrivileged && teamList.length !== 1 && (
                  <div className='dash-card rp-contribution-card rp-contribution-card--inline'>
                    <div className='dash-card-header rp-contribution-header'>
                      <div className='rp-overview-copy'>
                        <p className='dash-card-title'>{tr("Team Contribution")}</p>
                        <p className='dash-card-subtitle'>
                          {overviewContributionFilter === 'billable'
                            ? tr("Employees ranked by billable hours")
                            : overviewContributionFilter === 'non_billable'
                              ? tr("Employees ranked by non-billable hours")
                              : tr("All active employees ranked by tracked hours")}
                        </p>
                      </div>
                      <div className='rp-contribution-header-actions' ref={contributionDateMenuRef}>
                        <div style={{ position: 'relative' }}>
                          <button
                            type='button'
                            className='rp-overview-filter rp-overview-filter--selected'
                            onClick={() => setContributionDateMenuOpen((v) => !v)}
                          >
                            <span>{overviewRangeLabel}</span>
                            <span className='rp-overview-filter-caret' />
                          </button>
                          {contributionDateMenuOpen && (
                            <div className='rp-overview-date-menu'>
                              <div className='rp-overview-date-menu-tabs'>
                                <button
                                  type='button'
                                  className={overviewRangeMode === 'month' ? 'rp-overview-pill rp-overview-pill--active' : 'rp-overview-pill'}
                                  onClick={() => setOverviewRangeMode('month')}
                                >{tr("Month")} </button>
                                <button
                                  type='button'
                                  className={overviewRangeMode === 'range' ? 'rp-overview-pill rp-overview-pill--active' : 'rp-overview-pill'}
                                  onClick={() => setOverviewRangeMode('range')}
                                >{tr("Date Range")} </button>
                              </div>
                              {overviewRangeMode === 'month' ? (
                                <div className='rp-overview-date-menu-body'>
                                  <DatePicker locale={getLocale() === "de-DE" ? deDateLocale : enDateLocale}
                                    inline
                                    selected={overviewMonthDate}
                                    onChange={(date) => {
                                      if (date instanceof Date && !Number.isNaN(date.getTime())) {
                                        setOverviewMonthDate(startOfMonth(date));
                                        setContributionDateMenuOpen(false);
                                      }
                                    }}
                                    showMonthYearPicker
                                    maxDate={new Date()}
                                    calendarStartDay={auth.user_properties !== null && auth.user_properties !== undefined ? auth.user_properties.firstDayOfWeek : firstDayOfWeek}
                                  />
                                </div>
                              ) : (
                                <div className='rp-overview-date-menu-body rp-overview-date-menu-body--range'>
                                  <DateRangePicker
                                    onChange={handleOverviewDateRangeSelect}
                                    ranges={overviewDateRange}
                                    weekStartsOn={auth.user_properties !== null && auth.user_properties !== undefined ? auth.user_properties.firstDayOfWeek : firstDayOfWeek}
                                    maxDate={new Date()}
                                  />
                                </div>
                              )}
                            </div>
                          )}
                        </div>
                        <button
                          type='button'
                          className={overviewContributionFilter === 'all' ? 'rp-overview-pill rp-overview-pill--active' : 'rp-overview-pill'}
                          onClick={() => setOverviewContributionFilter('all')}
                        >{tr("All")} </button>
                        <button
                          type='button'
                          className={overviewContributionFilter === 'billable' ? 'rp-overview-pill rp-overview-pill--active' : 'rp-overview-pill'}
                          onClick={() => setOverviewContributionFilter('billable')}
                        >{tr("Billable")} </button>
                        <button
                          type='button'
                          className={overviewContributionFilter === 'non_billable' ? 'rp-overview-pill rp-overview-pill--active' : 'rp-overview-pill'}
                          onClick={() => setOverviewContributionFilter('non_billable')}
                        >{tr("Non-billable")} </button>
                      </div>
                    </div>

                    <div className='dash-card-body rp-contribution-body'>
                      {overviewContributionRankedRows.length > 0 ? (
                        <div className='rp-contribution-table-wrap'>
                          <div className='rp-contribution-table-header' style={{ gridTemplateColumns: overviewContributionGridTemplate }}>
                            <div className='rp-contribution-head rp-contribution-head--name'>Name</div>
                            <div className='rp-contribution-head rp-contribution-head--hours'>{overviewContributionMetricLabel}</div>
                            <div className='rp-contribution-head rp-contribution-head--split'>{tr("Billable vs Non-billable")}</div>
                            <div className='rp-contribution-head rp-contribution-head--logged'>{tr("Billable %")}</div>
                            <div className='rp-contribution-head rp-contribution-head--billable'>Status</div>
                          </div>
                          <div className='rp-contribution-table-body'>
                            {overviewContributionRankedRows.map((row, index) => {
                              const initials = row.name
                                .split(' ')
                                .filter(Boolean)
                                .slice(0, 2)
                                .map((part) => part[0])
                                .join('')
                                .toUpperCase() || '?';
                              const displayedHours = overviewContributionFilter === 'billable'
                                ? row.billable_ms
                                : overviewContributionFilter === 'non_billable'
                                  ? row.non_billable_ms
                                  : row.tracked_ms;
                              const pct = Math.max(0, Math.min(100, Number(row.billable_percent || 0)));
                              const billableWidth = Math.max(0, Math.min(100, pct));
                              const nonBillableWidth = Math.max(0, 100 - billableWidth);
                              const rankLabel = row.isLeader
                                ? overviewContributionFilter === 'billable'
                                  ? tr("Top billable contributor")
                                  : overviewContributionFilter === 'non_billable'
                                    ? tr("Top non-billable contributor")
                                    : tr("Top contributor")
                                : row.isTop
                                  ? `Top ${row.rank}`
                                  : row.isLow
                                    ? tr("Low performer")
                                    : `#${row.rank}`;

                              return (
                                <div
                                  className={
                                    row.isLeader
                                      ? 'rp-contribution-row rp-contribution-row--matrix rp-contribution-row--top rp-contribution-row--leader'
                                      : row.isTop
                                        ? 'rp-contribution-row rp-contribution-row--matrix rp-contribution-row--top'
                                        : row.isLow
                                          ? 'rp-contribution-row rp-contribution-row--matrix rp-contribution-row--low'
                                          : 'rp-contribution-row rp-contribution-row--matrix'
                                  }
                                  style={{ gridTemplateColumns: overviewContributionGridTemplate }}
                                  key={row.user_id || index}
                                >
                                  <div className='rp-contribution-cell rp-contribution-cell--name'>
                                    <span className={row.isLeader ? 'rp-contribution-rank rp-contribution-rank--leader' : 'rp-contribution-rank'}>
                                      {row.isLeader ? (
                                        <svg width='14' height='14' viewBox='0 0 24 24' fill='currentColor'>
                                          <path d='M12 2l2.4 7.4H22l-6.2 4.5 2.4 7.4L12 17l-6.2 4.3 2.4-7.4L2 9.4h7.6z'/>
                                        </svg>
                                      ) : row.rank}
                                    </span>
                                    <span className='rp-contribution-avatar'>{initials}</span>
                                    <div className='rp-contribution-meta'>
                                      <div className='rp-contribution-name-wrap'>
                                        <span className='rp-contribution-name'>{row.name}</span>
                                        {row.isLeader && (
                                          <span className='rp-contribution-leader-badge'>
                                            {overviewContributionFilter === 'billable'
                                              ? tr("Top billable contributor")
                                              : overviewContributionFilter === 'non_billable'
                                                ? tr("Top non-billable contributor")
                                                : tr("Top contributor")}
                                          </span>
                                        )}
                                        {row.workspace_role && (
                                          <span className='rp-contribution-role'>{row.workspace_role}</span>
                                        )}
                                      </div>
                                    </div>
                                  </div>

                                  <div className='rp-contribution-cell rp-contribution-cell--hours'>
                                    <strong className='rp-contribution-total-hours'>{formatOverviewDuration(displayedHours)}</strong>
                                    <span className='rp-contribution-total-meta'>
                                      {overviewContributionFilter === 'all'
                                        ? `${row.entries} entries`
                                        : `${formatOverviewDuration(row.tracked_ms)} total tracked`}
                                    </span>
                                  </div>

                                  <div className='rp-contribution-cell rp-contribution-cell--split'>
                                    <div className='rp-contribution-split-bar'>
                                      <span className='rp-contribution-split-bar-fill rp-contribution-split-bar-fill--billable' style={{ width: `${billableWidth}%` }} />
                                      <span className='rp-contribution-split-bar-fill rp-contribution-split-bar-fill--nonbillable' style={{ width: `${nonBillableWidth}%` }} />
                                    </div>
                                    <div className='rp-contribution-split-legend'>
                                      <span>{tr("Billable")} {formatOverviewDuration(row.billable_ms)}</span>
                                      <span>{tr("Non-billable")} {formatOverviewDuration(row.non_billable_ms)}</span>
                                    </div>
                                  </div>

                                  <div className='rp-contribution-cell rp-contribution-cell--logged'>
                                    <strong className='rp-contribution-logged'>{pct.toFixed(1)}%</strong>
                                  </div>

                                  <div className='rp-contribution-cell rp-contribution-cell--billable'>
                                    <span className={row.isLeader ? 'rp-contribution-status rp-contribution-status--leader' : row.isTop ? 'rp-contribution-status rp-contribution-status--top' : row.isLow ? 'rp-contribution-status rp-contribution-status--low' : 'rp-contribution-status'}>
                                      {rankLabel}
                                    </span>
                                  </div>
                                </div>
                              );
                            })}
                          </div>
                        </div>
                      ) : (
                        <div className='dash-empty-state rp-overview-empty'>
                          <svg width='32' height='32' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.5'>
                            <circle cx='12' cy='12' r='10' />
                            <path d='M12 8v4m0 4h.01' />
                          </svg>{tr("No employee contribution data available")} </div>
                      )}
                    </div>
                  </div>
                )}

                {/* Project breakdown table */}
                <div className='dash-card rp-breakdown-card'>
                  <div className='dash-card-header rp-breakdown-card-header'>
                    <div>
                      <p className='dash-card-title'>{tr("Project Breakdown")}</p>
                      <p className='dash-card-subtitle'>{tr("Tracked time by project for the selected period")}</p>
                    </div>
                    <div className='rp-breakdown-total'>
                      <span className='rp-breakdown-total-label'>{tr("Total Hours")}</span>
                      <strong className='rp-breakdown-total-value rp-breakdown-total-time'>
                        <span className='rp-breakdown-th'>{clockedTime.hours}</span>
                        <span className='rp-breakdown-tsep'>:</span>
                        <span className='rp-breakdown-tm'>{clockedTime.minutes}</span>
                        <span className='rp-breakdown-ts'>:{clockedTime.seconds}</span>
                      </strong>
                    </div>
                  </div>
                  <div className='rp-breakdown-header'>
                    <div className='rp-breakdown-col-title' onClick={()=>sortProjectArray()}>
                      <span>{tr("Project")}</span>
                      <span className='rp-sort-arrows'><i className='fa fa-angle-up'/> <i className='fa fa-angle-down'/></span>
                    </div>
                    <div className='rp-breakdown-col-dur' onClick={()=>sortProjectDuration()}>
                      <span>{tr("Duration")}</span>
                      <span className='rp-sort-arrows'><i className='fa fa-angle-up'/> <i className='fa fa-angle-down'/></span>
                    </div>
                  </div>
                  {projectArray.map((item, index) => (
                    <div
                      className='rp-breakdown-row'
                      key={index}
                      onClick={() => projectOnClick(item.project_id, item.project_name)}
                      style={canViewProjectDetail ? { cursor: 'pointer' } : { cursor: 'default' }}
                    >
                      <div className='rp-breakdown-row-name'>
                        <span className='rp-project-dot' style={{background: item.projectColor || '#a0aec0'}}/>
                        <span className='rp-project-name' style={{color: item.projectColor}}>{item.project_name}</span>
                      </div>
                      <div className='rp-breakdown-row-dur'>
                        {item.time.split(':').length === 1 ? (
                          <span className='meter-minute'>{item.time}</span>
                        ) : (
                          <span className='rp-time-display'>
                            <span className='meter-hour'>{item.time.split(':')[0]}:</span>
                            <span className='meter-minute'>{item.time.split(':')[1]}:</span>
                            <span className='meter-sec'>{item.time.split(':')[2]}</span>
                          </span>
                        )}
                      </div>
                    </div>
                  ))}
                  {projectArray.length === 0 && (
                    <div className='dash-empty-state'>{tr("No data for selected period")}</div>
                  )}
                </div>
              </div>
            </>
          ) : tab === 2 ? (
            <Suspense fallback={<Loader />}>
              <Detailed detailedList={detailedList} sortFunction={sortDetailedList}/>
            </Suspense>
          ) : ''}

        </div>
        <Footer />
      </div>
      <div id='search'>
        <button type='button' className='close'>
          ×
        </button>
        <form>
          <input type='search' value='' placeholder={tr("type keyword(s) here")} />
          <button type='submit' className='btn btn-primary'>{tr("Search")} </button>
        </form>
      </div>
    </div>
  );
}

Date.prototype.getWeek = function () {
  var date = new Date(this.getTime());
  date.setHours(0, 0, 0, 0);
  // Thursday in current week decides the year.
  date.setDate(date.getDate() + 3 - ((date.getDay() + 6) % 7));
  // January 4 is always in week 1.
  var week1 = new Date(date.getFullYear(), 0, 4);
  // Adjust to Thursday in week 1 and count number of weeks from date to week1.
  return (
    1 +
    Math.round(
      ((date.getTime() - week1.getTime()) / 86400000 -
        3 +
        ((week1.getDay() + 6) % 7)) /
        7
    )
  );
};
